export default {
  cash: 'Cash',
  pps: 'PPS',
  FPS: 'FPS',
  'VISA / Mastercard': 'VISA / Mastercard',
  Cheque: 'Cheque',
  '7-11': '7-11',
  wait: 'Please wait...',
  error: 'An error occurred. Please try again later',
  header: {
    news: 'NEWS',
    our_company: 'OUR COMPANY',
    awards: 'AWARDS',
    customer_service: 'CUSTOMER SERVICE',
    business_enquiries: 'BUSINESS ENQUIRY',
    change_lang: '中文',
    find_carpark: 'FIND CAR PARK',
    my_account: 'MY PAGE',
    iMONTHLY: 'i-MONTHLY ',
    login: 'LOG IN',
    logout: 'LOG OUT',
    cart: 'CART',
    MobileApp: 'MOBILE APP',
    search: 'Search this site',
    CartText: 'Your cart is currently empty',
    PageTitle: 'Wilson Parking(Holdings) Limited',
    CartCheckout: 'CHECK OUT',
    jobVacancies: 'JOB VACANCIES',
  },
  footer: {
    Home: 'HOME',
    Wilson_Group: 'Wilson Group',
    Mack_Parking: 'Mack Parking',
    Wash_Wax: 'Wash & Wax',
    Wilson_Storage: 'Wilson Storage',
    FIND_CAR_PARK: 'FIND CAR PARK',
    iMONTHLY_PARKER_SIGN_IN: 'i-MONTHLY PARKER SIGN IN',
    iMONTHLY_PARKER_SIGN_OUT: 'i-MONTHLY PARKER SIGN OUT',
    Registration: 'Registration',
    Cart: 'Cart',
    My_Account: 'My Account',
    Forgot_Password: 'Forgot Password',
    iMonthlyFAQ: 'i-Monthly Tutorial & FAQ',
    BOOK_iHOURLY: 'BOOK i-HOURLY',
    iHourlyFAQ: 'i-Hourly Tutorial & FAQ',
    NEWS: 'NEWS',
    OUR_COMPANY: 'OUR COMPANY',
    AWARDS: 'AWARDS',
    CUSTOMER_SERVICE: 'CUSTOMER SERVICE',
    BUSINESS_ENQUIRY: 'BUSINESS ENQUIRY',
    PRIVACYPOLICY: 'PRIVACY POLICY',
    DISCLAIMER: 'DISCLAIMER',
    Wilson_Parking: 'Wilson Parking (China)',
    promobarTitle: 'PPS Payment Suspension',
    promobarContentTitle:
      'Monthly parking payment by PPS will be suspended with effect from 1 Jan 2023. Please use other payment methods for monthly parking payment.',
    promobarDetail1:
      '\nFrom 23 Nov to 5 Dec, you can apply for Transport Department Quarterly Parking Ticket (Jan to Mar 2023) of Tsuen Wan, Kwai Fong and Tin Hau Multi-Storey Car Park online.\n\n\nFor respective guidance note, please refer to Tsuen Wan, Kwai Fong and Tin Hau Car Park detail page at this site.',
    promobarDetail2: 'Click here to apply quarterly parking ticket',
    promobarDetail3: '(https://www.tdcarpark.com.hk/ )',
    wilsonparking: 'Wilson Parking (China)',
    CopyRight: '©2018 Wilson Parking. All rights reserved.',
    Office:
      'Office: Rm 2901, 29/F, Metroplaza Tower 1, Hing Fong Road, Kwai Chung, N.T., Hong Kong/ Tel: 2830-3845',
    Email: 'Email:',
    wp: 'Wilson Parking (Holdings) Limited',
    licence: 'PMC Licence: C-544339',
    jobVacancies: 'JOB VACANCIES',
  },

  Login: {
    SIGN_IN_REGISTER: 'SIGN IN / REGISTER',
    Sign_in: 'i-MONTHLY PARKER SIGN IN',
    Username: 'Username',
    Password: 'Password',
    RememberMe: 'Remember me',
    Forgot_Password: 'Forgot password?',
    Login: 'LOG IN',
    signUp: 'Sign Up',
    Registration: 'REGISTRATION',
    First_time_login: 'PARK泊CARD CUSTOMER FIRST-TIME SIGN IN',
    ParkCard: 'Park泊Card No.',
    ContactNo: 'Contact No.',
    Activate: 'ACTIVATE YOUR ACCOUNT',
    CreateAc: 'CREATE AN ACCOUNT',
    NewCustomer:
      'New customer? Register now and enjoy the many online services in just a couple of clicks.',
    ReisterNow: 'REGISTER NOW',
    Email: 'Email Address',
    Error: 'Incorrect username or password.',
    notExist: 'The email address does not exist',
    signInTitle: 'Enjoy the many online services in just a couple of clicks. Sign up now.',
    pleaseEnter:
      'Please enter mobile phone number registered at car park if you are a monthly parking customer.',
    invalidToken: 'Invalid Token',
    passwordError: 'The password entered is incorrect. Please try again.',
    emailError: 'The email address entered is invalid. Please try again.',
  },

  Myprofile: {
    Headertext:
      'Timely update of personal and vehicle information is highly recommended to ensure the parking services will not be interrupted.',
    CustomerInf: 'CUSTOMER INFORMATION',
    Prefix: 'Prefix',
    FirstNameEng: 'First Name (Eng)',
    LastNameEng: 'Last Name (Eng',
    FirstNameZh: 'First Name (中文)',
    LastNameZh: 'Last Name (中文)',
    Address: 'Address',
    lang: 'Preferred Language',
    ChangePassword: 'CHANGE PASSWORD',
    NewPassword: 'New Password',
    ConfirmPassword: 'Confirm New Password',
    PasswordRequest:
      'Your password should be alphanumeric with at least one letter in capital and minimum 8 characters.',
    ChangeMobileNo: 'CHANGE MOBILE NUMBER',
    MobileNo: 'Mobile Number',
    ReceiveSMS: 'RECEIVE SMS',
    VerCode: 'Verification Code',
    Verify: 'VERIFY',
    WishPro: 'I wish to receive promotional newsletters, marketing emails and SMS.',
    WishSMS: 'I wish to receive notifications via SMS.',
    Reset: 'RESET',
    Update: 'UPDATE',
    SavedPayment: 'SAVED PAYMENT METHODS (CREDIT CARD)',
    NoSaved: 'You have not saved any payment methods',
    AddCard: 'ADD PARK泊CARD',
    ParkCardNo: 'Park泊Card no.',
    PleaseSelcet: 'PleaseSelect',
    Region: 'Region',
    District: 'District',

    EmailError: 'Invalid email address.',
    ConfirmEmailError: 'Invalid confirm email address.',
    PasswordError: 'Please enter a valid password in 8-15 characters.',
    ConfirmPasswordError: 'Please enter the same as password in 8-15 characters.',
    prefixError: 'Please select a prefix.',
    firstNameError: 'Please enter your first name.',
    lastNameError: 'Please enter your last name',
    languageError: 'Please select a language',
    phoneError: 'Invalid mobile number.',
    Required: 'Required',
    remove: 'remove',

    Updated: 'YOUR PROFILE HAS BEEN UPDATED',
    UpdatedBack: 'BACK TO PREVIOUS PAGE',

    ActiveExpiredTitle: 'ACCOUNT ACTIVATION EXPIRED',
    ActiveExpiredText:
      'Please enter your registered estmail to get a link to reactivate your account.',
    ActiveExpiredA: 'RESEND',
    ActiveSuccessTitle: 'ACTIVATION SUCCESSFUL',
    ActiveAlreadyTitle: 'YOUR ACOUNT HAS BEEN ACTIVATED',
    ActiveAlreadyText: 'Please enter your username and password to sign in',
    ActiveSuccessText:
      'Congrats! You may now log-in to swiftly book, renew, change and terminate parking services. You can also change your registered vehicle registration mark, view past transaction history, update your account details and more.',
    PPcardError:
      'The car park facility number cannot be found, please contact our customer service.',
    confirmRemoveCard: 'Are you sure to remove {{token}}?',
    tnc: 'Your personal data will not be kept longer than it is necessary as per statutory requirement. For details, please visit',
    PrivacyPolicy: 'Privacy Policy',
    importantText:
      'Once your account is deleted, you can no longer use book/renew i-Monthly Parking and other online services. Besides, all your previous payment and parking records will be permanently removed.',
    confirmText:
      'Important: Once your account is removed, you can no longer use iPark – contactless parking and a range of convenient online payment services, including book / renew i-Monthly Parking.  Besides, all previous records of your payment and parking services will be permanently removed.',
    confirmText1: 'Are you sure you want to remove your account?',
    successText: 'Your account has been successfully deleted',
    successText1: 'Thank you for choosing Wilson Parking, we look forward to serving you again.',
    deleteAccount: 'DELETE ACCOUNT',
    delete: 'DELETE',
    readAndAgreed: 'I have read and agreed the Terms and Conditions.',
    tncError: 'Please read and agree the Terms and Conditions',
    notAvailbleChangeLPN: 'This Booking is not available to change LPN.',
  },

  CsList: {
    CUSTOMER_SERVICE: 'CUSTOMER SERVICE',
    BUSINESS_ENQUIRY: 'BUSINESS ENQUIRY',
    Hotline: 'CUSTOMER SERVICE HOTLINE',
    HotlineText:
      'We always want to hear from you. Contact us and share your enquiries and feedbacks.',
    OfficeHour: 'Office Hour',
    OfficeHour1: 'Mon - Fri 9:00am - 5:00pm',
    Except: '(Except Public Holidays)',
    Tel: 'Telephone',
    TelNo: '+852 2830-3845',
    EmailAddress: 'Email Address',
    LeaveMsg: 'Please leave us your message below. We will contact you shortly.',
    ContactInf: 'CONTACT INFORMATION',
    Name: 'Name',
    Email: 'E-mail',
    ContactNo: 'Contact No.',
    CompanyName: 'Company Name',
    YourMsg: 'YOUR ENQUIRY',
    Subject: 'Subject',
    Msg: 'Enquiry details',
    Agree: 'I agree to',
    Policy: 'the Privacy Policy Statement of Personal Information Collection',
    Reset: 'RESET',
    Submit: 'SUBMIT',
    SentOutTitle: 'SENT OUT SUCCESSFUL',
    SentOutText: 'Thank you for your enquiry, we will contact you shortly.',
    SentOutButton: 'GO TO HOME',
    NameError: 'Please enter your name.',
    EmailError: 'Invalid email address',
    PhoneError: 'Invalid phone number',
    SubjectError: 'Please enter a subject.',
    ContentError: 'Please enter your message.',
    CompanyNameError: 'Please enter your Company Name.',
    PasswordError: 'Please enter valid login details.',
  },

  MyAccountTap: {
    MyAccount: 'MY ACCOUNT',
    iMONTHLY: 'I-MONTHLY',
    IPARK: 'IPARK',
    PAYMENTRECORDS: 'PAYMENT RECORDS',
    MYPROFILE: 'MY PROFILE',
    Previous: 'Previous Page',
    Page: 'PAGE',
    Of: 'OF',
    Next: 'Next Page',
    Pagezh: '',
    nextStep: 'NEXT',
  },

  MyAccount: {
    WaitingList: {
      confirmed: 'On the waiting list',
      refNo: 'Ref No.',
      createdAt: 'Created at',
      cancelWaiting: 'CANCEL WAITING',
      addWaiting: 'JOIN THE WAITING LIST',
      confirmCancel: 'Confirm removing vehicle from waiting list?',
      selectVehicle: 'Select Vehicle for Waiting List',
      pleaseWait: `We will contact you when the i-Monthly service is available.<br/>You may manage your i-Monthly Waiting List in “My Page”.`,
      appliedSuccess: 'JOIN SUCCESSFULLY',
      goToMyPage: 'Go to My Page',
      changeVehicleTitle: 'Change Vehicle for Waiting List',
      changeVehicle: 'Change Vehicle',
      addNewCar: 'Create New Car',
      selectCar: 'Select Car',
      haveConfirmedWaiting: 'Vehicle is already on the waiting list',
    },
    iMonthly: {
      PleaseRead: 'PLEASE READ CAREFULLY',
      important: 'IMPORTANT:',
      reminderContent: `
          Our renewal period runs from the 22nd to the last day of every month, and you can renew
          monthly parking services for one month at a time. It’s important that customers renew the
          monthly parking service upon expiry, otherwise the service will be terminated.
          `,
      AssignedCar: 'Assigned Car',
      ServicePeriod: 'Service Period',
      ServiceId: 'Service ID',
      ServiceStatus: 'Service Status',
      Service: 'Service',
      LastPaymentDate: 'Last Payment Date',
      ExpiryDate: 'Expiry Date',
      RENEW: 'RENEW',
      CHANGE: 'CHANGE',
      TERMINATE: 'TERMINATE',
      ChangeCar: 'Change',
      status: {
        pending: 'Pending',
        active: 'Active',
        terminated: 'Terminated',
        expired: 'Expired',
        changed: 'Changed',
        renewed: 'Renewed',
        paid: 'Paid',
        settled: 'Settled',
        overpaid: 'Overpaid',
        underpaid: 'Underpaid',
        unknown: '-',
        temporary: 'Temporary',
        cancelled: 'Cancelled',
        tempChangeTerminated: 'Terminated(Temporary)',
        processed: 'Processed',
      },
      successfullyTerminated: 'Successfully terminated booking',
      SomethingWrong: 'Something went wrong. Unable to terminate booking',
      confirmTerminate: 'Are you sure to terminate this booking?',
      confirm: 'Confirm',
      cancel: 'Back',
      vehicleIsPresentError:
        'The vehicle registration number cannot be changed for vehicles that have entered the carpark',
      hourlyPresentReminder:
        'The registration mark selected is an hourly parking vehicle in this car park, you cannot change its status to monthly. Please try again after the vehicle has left this car park. ',
    },
    PaymentRecord: {
      registrationMark: 'Vehicle Registration Mark',
    },
    changeCarPark: 'CHANGE OF CAR PARK / SERVICE',
    selectNewCarPark: 'Please select new assigned car park or service:',
    serviceFee: 'Service Fee',
    fillError: 'Please fill in all the information',
    changeMoreThanOne: 'Change of vehicle registration number can only be made once each month ',
  },

  News: {
    NEWS: 'NEWS',
    N0Title: 'Wetland Public Vehicle Park',
    N0Text: 'Wetland Public Vehicle Park in Tin Shui Wai is open on 1st July, 2022',
    N1Title: 'Trusted Brand Platinum Award',
    N1Text: `Wilson Parking is awarded the Reader’s Digest Trusted Brand Platinum Award 2022`,
    Readmore: 'READ MORE',
    N3Title: 'EV-Charge Zone Admiralty',
    N3Text: `Enjoy up to 4 Hours Free Charging*!`,
    N4Title: 'TD Quarterly Parking',
    N4Text: 'You can apply for Transport Department Quarterly Parking Ticket online',
    N5Title: 'Wilson Parking Mobile App',
    N5Text: 'Download the Wilson Parking Mobile App to kick start your smart parking journey!',
    N6Title: `Int'l Trade Centre Opening`,
    N6Text: 'International Trade Centre in Tsuen Wan is open on 1st July, 2022',
    N7Title: 'Lucky Plaza Opening',
    N7Text: 'Lucky Plaza in Shatin is open on 1st July, 2022',
    N8Title: 'Tai Po Mega Mall Car Park',
    N8Text: 'Tai Po Mega Mall Mulit-Storey Car Park is open on 1st August, 2022',
    N9Title: 'Yuk Yat Street Re-open',
    N9Text: 'Yuk Yat Street in To Kwa Wan is re-open on 1st Sept, 2022',
    N10Title: 'Free Ozone Sterilization x3',
    N10Text: 'Exclusive offer upon SmarTone Home 5G Broadband Subscription',
    N11Title: 'EV-Charge Zone Admiralty',
    N11Text: '$30/hr only for Quick Charge. Come and Experience!',
    N12Title: 'West Kln Cultural District',
    N12Text: 'Car Parks at West Kowloon Cultural District are open on 15 December, 2022',
    N13Title: 'Car Parks Opening Jan 2023',
    N13Text: 'New Car Parks open on 1 January, 2023',
    N1Detailtext1:
      'We are delighted to announce that we have been awarded the “Reader’s Digest Trusted Brand Platinum Award” for ten consecutive years.',
    N3Detailtext1:
      '<p>Key Features:</p><p>- Located in central business district - Admiralty Car Park Level 1, Block A</p><p>- 13 quick and medium EV-Charge Bays*</p><p>- EV-Charge Bays online booking service [Coming soon]</p></p><p style="margin-top:40px">*EV-Charge Bay Surcharge Applies.</p>',
    N4Detailtext1:
      '<p>You can apply for Transport Department Quarterly Parking Ticket online</p><div><a>Kwai Fong Car Park</a></div><div><a>Tsuen Wan Car Park</a></div><div><a>Tin Hau Car Park</a></div><div style="margin-top:40px"><a href="https://www.tdcarpark.com.hk/" target="_blank" style="color:black;font-size:0.875rem;font-weight:bolder;">>> Click here to apply quarterly parking ticket</a></div>',
  },

  Our_company: {
    Our_company: 'OUR COMPANY',
    HeaderText:
      'Wilson Parking is a world class parking consultant, manager and operator with more than 45 years of experience. Wilson Parking in Hong Kong SAR and other mainland cities are wholly owned subsidiaries of Sun Hung Kai Properties Limited.',
    ESTABLISHED: 'ESTABLISHED',
    MANAGE: 'MANAGE',
    BAYS: 'BAYS',
    OPERATE: 'OPERATE',
    CARS_PARKS: 'CAR PARKS',
    VISION: 'VISION',
    VISION_text:
      'We aim to provide world-class transport-related services, and satisfy our customers with passion and professionalism.',
    MISSION: 'MISSION',
    MISSION_text:
      'We are committed to provide quality innovative products and services to enhance safety, reliability and efficiency.',
    VALUES: 'VALUES',
    VALUES_text:
      'Our company values are : Customer Focus, Innovation & Technology, Service Excellence, Teamwork and Active Enhancement.',
    QUALITY_ASSURANCE: 'QUALITY ASSURANCE',
    h1: 'Wilson Parking nurtures a strong customer centred culture. It is committed to providing quality innovative services that significantly enhance safety, reliability and efficiency.',
    h2: 'Twenty years ago, Wilson Parking were proud to become the first car park company in Hong Kong to achieve the ISO 9002 certification for its quality assurance systems. While this was an important milestone, we have continued to work diligently ever since to improve our quality systems.',
    h3: 'Currently, four of the most critical certifications we have achieved are in the areas of quality management, environmental management, customer satisfaction, occupational health and safety management systems, namely: ISO 9001:2015; ISO 14001:2015; ISO 10002:2018; ISO 45001:2018.',
    h4: 'Integrated management systems are fully documented and regularly reviewed by a special committee at the operations level, ensuring that all our staff conscientiously understand and meet the demands of each system and procedure.',
    h5: 'In addition, since 2010 Wilson Parking has been accredited in the Q-Mark service Scheme, an initiative that enhances the quality of services and management systems in compliance with internationally-recognized standards, while also promoting the concept of quality services locally and overseas with regular surveillance and on-the-spot audits.',
  },

  iHourlyFAQ: {
    Header: 'i-HOURLY PARKING SERVICE TUTORIAL & FAQ',
    h1Q: 'WHAT IS i-HOURLY?',
    h1T: 'You can easily book hourly parking in advance through our online booking system. We guarantee a parking space at the moment you arrive at the car park entrance, meaning no more lining up!',
    h2Q: 'HOW DOES i-HOURLY WORK?',
    h2A1: "1. Enter car park details page of your desired car park. Click the 'BOOK' button next to the hourly rate.",
    h2A2: '2. Select the date, entry time and then enter your basic details.',
    h2A3: '3. Pay the handling fee by VISA / MasterCard or PPS. Booking confirmation will be sent to you by email / SMS.',
    h2A4: '4. Drive to the chosen car park at your selected time*and get your parking space straight away.',
    h2T1: '* Normal hourly parking rates will be applied from the time of entry.',
    h2T2: 'If you have questions on your booking prior to your arrival to the car park, you can contact our i-Hourly Team at 2830-3845 during business hours from Monday to Friday or email',
    h2T3: '',
    FAQ: 'i-HOURLY FAQ',
    Q1: '1. Can I get a refund if I do not use my booking?',
    A1: 'No. Handling fee is not refundable.',
    Q2: '2. Why is the timeslot/car park I want to book not shown?',
    A2: 'Currently i-Hourly booking is only available at selected car parks. If you cannot find an availability please try an alternate time or car park.',
    Q3: '3. Why do you charge a handling fee?',
    A3: 'The handling fee ensures that the i-Hourly service is reserved exclusively for you at your pre-booked car park, date and time.',
    Q4: '4. Can I cancel or amend my booking? How?',
    A4: 'Once your booking is confirmed, it cannot be cancelled. You are able to make changes to your booking as long as they are made at least 24 hours in advance by emailing ',
    A41: ' Please note that it is subject to service availability.',
    A42: ' Please note that it is subject to service availability.',
    Q5: '5. How do I know my booking has been accepted?',
    A5: 'Once your payment is successful, you will receive a booking confirmation by email / SMS.',
    Q6: '6. What do I need to do when I enter the car park?',
    A6: 'Different arrangements may be applied to each car park. Please follow the instructions listed on your booking confirmation. When you arrive at the car park, our staff will be happy to assist you.',
    Q7: '7. What will happen if I arrive later than my intended entry time?',
    A7: 'Your booking will be valid for 1 hour according to the booked time. No compensation will be made.',
    Q8: '8. How far ahead can I make a reservation?',
    A8: 'Bookings can be made up to 14 days in advance.',
    Q9: '9. What is the minimum lead time for booking?',
    A9: 'Bookings must be made at least 24 hours in advance.',
    Q10: '10. Who should I contact if there is a problem with my booking?',
    A10: 'If you have questions on your booking prior to your arrival to the car park, you can contact our i-Hourly Team at 2830-3845 during business hours from Monday to Friday or email',
    A101: '',
  },

  iMonthlyFAQ: {
    Header: 'i-MONTHLY PARKING SERVICE TUTORIAL & FAQ',
    HeaderText: 'To enjoy the i-Monthly online service, simply become an "i-Monthly Parker".',
    HeaderText1: 'If you are not an i-Monthly parker, please',
    HeaderText2: 'here.',
    HeaderText2zh: '',
    HeaderText2en: 'register ',

    Title1: 'i-MONTHLY TUTORIAL ',
    T1Q1: 'WHAT IS i-MONTHLY? HOW DOES IT WORK?',
    T1A1: 'As an i-Monthly Parker, you can handle a wide range of services in just a couple of clicks, anytime, anywhere. You can book, renew or change a monthly parking',
    T1A1a:
      'service, change vehicle registration marks, update your personal details and much more!',

    T1Q2: 'HOW DO I BOOK A NEW MONTHLY PARKING SERVICE?',
    T1Q2A1: '1. Sign-in to',
    T1Q2A11: 'i-MONTHLY PARKER.',
    T1Q2A2: '2. Go to',
    T1Q2A21: 'FIND CAR PARK',
    T1Q2A22: 'and search for your desired car park. ',
    T1Q2A3: '3. Select parking service and press ',
    T1Q2A31: 'BOOK.',
    T1Q2A4: '4. Confirm the details in your ',
    T1Q2A41: 'CART',
    T1Q2A42: 'and choose the access card pick-up method.',
    T1Q2A43: '',
    T1Q2A44: '',
    T1Q2A5:
      '5. Check out. A booking confirmation will be sent by email / SMS for successful booking.',

    T1Q3: 'HOW DO I RENEW MY MONTHLY PARKING SERVICE?',
    T1Q3A1: '1. Sign-in to ',
    T1Q3A11: 'i-MONTHLY PARKER.',
    T1Q3A2: '2. Go to ',
    T1Q3A21: 'MY SERVICES ',
    T1Q3A22: 'under ',
    T1Q3A23: 'MY ACCOUNT.',
    T1Q3A3: '3. Review and update the parking details.',
    T1Q3A4: '4. Press ',
    T1Q3A41: 'RENEW. ',
    T1Q3A42: 'The selected service will then be added to your ',
    T1Q3A43: 'CART.',
    T1Q3A5: '5. Confirm the details in your',
    T1Q3A51: 'CART ',
    T1Q3A52:
      'and check out. A renewal confirmation will be sent to you by email / SMS for successful payment.',

    T1Q4: 'HOW DO I UPDATE MY PERSONAL DETAILS?',
    T1Q4A1: '1. Sign-in ',
    T1Q4A11: 'to i-MONTHLY PARKER.',
    T1Q4A2: '2. Go to ',
    T1Q4A21: 'MY PROFILE ',
    T1Q4A22: 'under',
    T1Q4A23: ' MY ACCOUNT.',
    T1Q4A3: '3. Press ',
    T1Q4A31: 'UPDATE ',
    T1Q4A32: 'to confirm changes.',

    T1Q5: 'HOW DO I CHANGE MY VEHICLE REGISTRATION MARK?',
    T1Q5A1: '1. Sign-in to ',
    T1Q5A11: 'i-MONTHLY PARKER.',
    T1Q5A2: '2. Go to ',
    T1Q5A21: 'MY SERVICES ',
    T1Q5A22: 'under ',
    T1Q5A23: 'MY ACCOUNT.',
    T1Q5A3: '3. Select the parking service.',
    T1Q5A4: '4. Under ',
    T1Q5A41: 'ASSIGNED CAR ',
    T1Q5A42: 'press ',
    T1Q5A43: 'CHANGE.',
    T1Q5A5: '5. You may choose to change the vehicle registration mark on a ',
    T1Q5A51: 'temporary basis ',
    T1Q5A52: '(free of charge with a maximum of 5 days use) or on a ',
    T1Q5A53: 'permanent basis ',
    T1Q5A54: '*(an administration fee of HK$50 is payable).',
    T1Q5A6:
      '6. Enter your new vehicle registration mark and the commencement date (applicable to permanent change only). Press ',
    T1Q5A61: 'CONFIRM.',
    T1Q5A7: '7. Review the changes & check out for payable fees.',
    T1Q5A8: '8. A confirmation will be sent to you by email / SMS (for permanent change only).',
    T1Q5strt:
      '*Alternatively, you may change the vehicle registration mark permanently during the renewal process of your parking service and the administration fee will be waived. The new vehicle registration mark will be effective from the 1st day of your renewed service period.',

    T1Q6: 'HOW DO I CHANGE MY PARKING SERVICE?',
    T1Q6Text:
      'Changes can be made to your current parking service (e.g. change to a different car park or parking service). The changes will be effective from the 1st day of the renewed service period.',
    T1Q6A1: '1. Sign-in to ',
    T1Q6A11: 'i-MONTHLY PARKER.',
    T1Q6A2: '2. Go to ',
    T1Q6A21: 'MY SERVICES ',
    T1Q6A22: 'under ',
    T1Q6A23: 'MY ACCOUNT.',
    T1Q6A3: '3. Current parking service is shown.',
    T1Q6A4: '4. Press ',
    T1Q6A41: 'CHANGE. ',
    T1Q6A42: 'You may then select the car park and parking service desired.',
    T1Q6A5: '5. Confirm the details in your ',
    T1Q6A51: 'CART ',
    T1Q6A52: 'and check out.',

    Title2: 'i-MONTHLY FAQ',
    T2Q1: '1. WHY IS THERE NO SLOT AVAILABLE FOR THE SERVICE / CAR PARK I WANT TO BOOK ? ',
    T2A1: 'i-Monthly service is made available for selected car parks. If you are not able to find an availability, please try to select alternate car parks.',
    T2Q2: '2. CAN I GET A REFUND ON THE PARKING FEE IF I DO NOT USE MY BOOKING?',
    T2A2: 'No. Once the parking fee is paid, no refund will be made.',
    T2Q3: '3. HOW CAN I CHANGE MY REGISTERED VEHICLE REGISTRATION MARK? ',
    T2A3: 'You may make changes to your vehicle registration mark via your i-Monthly account. ',
    T2A31: 'Detail tutorial please refer to ',
    T2A32: 'here.',
    T2A3x: '',
    T2Q4: '4. HOW CAN I CHANGE MY CONTACT DETAILS?',
    T2A4: 'You can change contact details in ‘MY PROFILE’ under ‘MY ACCOUNT’. ',
    T2Q5: '5. WHERE CAN I CHECK MY BOOKING HISTORY?',
    T2A5: 'You can check booking history of parking services in ‘MY SERVICES’ under ‘MY ACCOUNT’.',
    T2Q6: '6. HOW DO I KNOW MY BOOKING HAS BEEN ACCEPTED? ',
    T2A6: 'Once your parking service booking has been processed and accepted, a confirmation will be sent to you by email / SMS.',
    T2Q7: '7. WHAT WILL HAPPEN IF I FORGET TO RENEW MY MONTHLY PARKING SERVICE?',
    T2A7: 'If the parking service is not renewed by the expiry date, the parking service will be terminated automatically.  ',
    T2Q8: '8. HOW FAR AHEAD CAN I BOOK MY MONTHLY PARKING?',
    T2A8: 'For booking made between 22nd to end of the month, you can either purchase sercive for the remaining days of the current month plus coming FULL month service; or start your monthly parking service on the 1st day of the coming month. ',
    T2Q9: '9. WHO SHOULD I CONTACT IF THERE IS A PROBLEM WITH MY BOOKING? ',
    T2A9: 'You may contact our i-Monthly team at 2830-3845 during business hours from Monday to Friday or email ',
    T2A91: '',
    T2Q10: "10. WHAT SHOULD I DO IF I LOST MY 'Park 泊 Card’?",
    T2A10:
      "Please notify us immediately if your 'Park 泊 Card' is lost. You may apply for a replacement card by paying an administration fee of HK$200.",
    T2Q11: '11. CAN I ENTER A DIFFERENT CAR PARK WITH ‘Park 泊 Card’ FROM THE ONE I BOOKED? ',
    T2A11:
      "Your 'Park 泊 Card' can only gain access to the car park where the parking service is booked.",
    T2Q12: '12. WHAT SHOULD I DO IF I FORGOT MY SIGN-IN NAME/ PASSWORD?',
    T2A12:
      'The ‘Username’ is your registered email address. If you have forgotten your password, you may reset it by clicking ‘Forgot password?’ at the SIGN IN / REGISTER section.',
    T2Q13: '13. HOW DO I CHANGE MY CURRENT MONTHLY PARKING SERVICE TO ANOTHER CAR PARK?',
    T2A13:
      'Changes can be made from 22nd to the end of each month and will be effective on the 1st day of the coming month. Detail please refer to',
    T2A131: 'here.',
    Title3: 'NEED HELP? ',
    T3Text:
      'You can contact our i-Monthly Team at 2830-3845 during business hours from Monday to Friday (excl. PH) or email ',
    T3Text1: '',
  },

  ForgotPassword: {
    Header: 'FORGOT PASSWORD',
    ResetByEmail: 'RESET BY EMAIL',
    Text: 'Enter your registered email to get a link to reset your password.',
    Email: 'Email',
    Submit: 'SUBMIT',
    Or: 'OR',
    ResetByMob: 'RESET BY MOBILE NUMBER',
    Step1: 'Enter your registered mobile number to get the reset password code.',
    Step2:
      'The reset password code will expire in 120 seconds. Customers may click on the resend button for a new SMS code after it has expired.',
    MobileNo: 'Mobile Number',
    ResetPasswordCode: 'Reset Password Code',
    ReceiveSMS: 'RECEIVE SMS',
    ReSend: 'RESEND SMS',
    Verify: 'VERIFY',
    ErrorEmail: 'Incorrect Account',
    Error: 'Error 401, Please try again',
    Error403: 'Error 403, Please try again',
    notExistPhone: 'User not found',
  },

  ResetPassword: {
    Title: 'RESET PASSWORD',
    Password: 'New Password',
    ComPassword: 'Confirm New Password',
    Reset: 'RESET',
    Submit: 'SUBMIT',
    ByEmailTitle: 'CONTINUE TO RESET PASSWORD',
    ByEmailText:
      'A reset password link has been sent to your registered email address. Please follow the instructions and reset the password accordingly.',
    ByEmailButton: 'BACK TO SIGN IN',
    ResetedTitle: 'YOUR PASSWORD HAS BEEN RESET',
    ResetedButton: 'RETURN TO SIGN IN',
    PasswordError:
      'Your password must be between 8 - 15 characters, and include at least one uppercase letter and one number.',
    ConfirmPasswordError: 'Please enter the same as password.',
  },

  Registration: {
    Header: 'NEW REGISTRATION',
    Required: 'Required field',

    Title1: 'SIGN IN INFORMATION',
    EmailPlaceholder: 'Will be used as username',
    Email: 'Email Address',
    ComEmail: 'Confirm Email Address',
    Password: 'Password',
    ComPassword: 'Confirm Password',
    PasswordRequest:
      'Your password should be alphanumeric with at least 8 characters including one capital letter.',

    Title2: 'CUSTOMER INFORMATION',
    Prefix: 'Prefix',
    FirstNameEng: 'First Name (Eng)',
    LastNameEng: 'Last Name (Eng)',
    FirstNameZh: 'First Name (中文)',
    LastNameZh: 'Last Name (中文)',
    Address: 'Address',
    PreferredLanguage: 'Preferred Language',
    Region: 'Region',
    District: 'District',

    Title3: 'CAR INFORMATION',
    Type: 'Type',
    PleaseSelect: 'Please Select',
    VehicleRegistrationMark: 'Vehicle Registration Mark',

    Title4: 'MOBILE NUMBER',
    Note: 'Please note that we need your mobile number to complete the registration process and to contact you in case of any emergency',
    Mobile: 'Mobile Number',
    VerificationCode: 'Verification Code',
    ReceiveSMS: 'RECEIVE SMS',
    Verify: 'VERIFY',
    Iagree: 'I agree',
    AgreeTerm: 'the Terms & Conditions of the use of Monthly Parking Services',
    AgreePrivacy: 'the Privacy Policy Statement of Personal Information Collection',
    WishPro: 'I wish to receive promotional newsletters, marketing emails and SMS.',
    WishSMS: 'I wish to receive notifications via SMS.',
    Reset: 'RESET',
    Register: 'REGISTER',

    EmailExistError: 'An account is already registered with your email address Please log in.',
    PhoneExistError: 'An account is already registered with your phone Please log in.',
    EmailError: 'Invalid email address.',
    EmailEnterError: 'Please enter your email',
    ConfirmEmailError: 'Invalid confirm email address.',
    ConfirmEmailEnterError: 'Please enter your confirm email',
    PasswordError: 'Please enter a valid password in 8-15 characters.',
    ConfirmPasswordError: 'Please enter the same as password in 8-15 characters.',
    prefixError: 'Please select a prefix.',
    firstNameError: 'Please enter your first name.',
    lastNameError: 'Please enter your last name',
    languageError: 'Please select a language',
    phoneError: 'Invalid mobile number.',
    phoneEnterError: 'Please enter your phone',
    VerificationCodeError: 'Please enter your verification code',
    UsedEmailError: 'The email address is taken, Please try another one.',
    TryLater: 'Please try again later.',
    registrationMarkError: 'Invalid vehicle registration mark.',

    registeredTitle: 'THANK YOU FOR CHOOSING WILSON PARKING',
    registeredText:
      'Your account is not active yet. You will receive an email with activation link, please click the link within 2 hours to complete your account activation.',
    registeredButton: 'CONTINUE TO ACCOUNT PAGE',
  },

  Disclaimer: {
    Title: 'DISCLAIMER',
    Text1:
      'This website is to provide information about Wilson Parking (Holdings) Limited ("the Company") and the services we offer for reference purpose.',
    Text2:
      'This website is provided on an "as is" and “as available” basis and without any warranty, guarantee or representation of any kind, either expressed or implied, including, without limitation any implied warranties or implied terms of merchantability or fitness for a particular purpose to the fullest extent permissible under the laws of Hong Kong Special Administrative Region although we have tried our best to make sure the information is accurate. Any web link from this site to other websites on the internet does not constitute an endorsement by the Company of such websites or any content thereof in particularly in terms of availability, accuracy, completeness or reliability.',
    Text3:
      'Information presented in this website is subject to change at any time without notice and the Company does not warrant or guarantee its completeness, reliability or accuracy. By accessing this website you agree that the Company will not be liable (whether in contract, tort or otherwise) for any direct, indirect or consequential loss arising from the use of or inability to use the information and materials contained in this website or from your access of other materials on the internet via web links from this site.',
    Text4:
      'The above exclusions and limitations apply to the fullest extent as permitted under the laws of Hong Kong Special Administrative Region.',
    Text5:
      'If there is any inconsistency or conflict between the English and Chinese versions, the English version shall prevail.',
  },

  Title: {
    Title: 'Wilson Parking(Holdings) Limited',
  },

  TabContainer: {
    iMONTHLY: 'I-MONTHLY',
    IPARK: 'IPARK',
    PAYMENT_RECORDS: 'PAYMENT RECORDS',
    MY_PROFILE: ' MY PROFILE',
    waitingList: 'I-MONTHLY\nWAITING LISTING',
  },

  Home: {
    promoimg1title: 'LEAVE IT TO US',
    promoimg1text:
      'We are proud to have been serving motorists in Hong Kong over 30 years. We strive to provide professional services with the most uptrend technology, as we know our customers are our priority, like always.',
    promoimg2title: 'PARK SMARTER',
    promoimg2text:
      'Having the new app with real time parking info and i-Monthly booking & payment – Anyone can be a parking guru !<br/>Download Now ! ',
    promoimg3title: 'HZMB Car Park',
    promoimg3text:
      'Pre-book Daily Parking fee is only HK$160 up ! Booking can be made 4 hours prior to your entry !<br/>Book Now > > >',
    promoimg4title: 'CHARGE UP !',
    promoimg4text:
      'Your strongest backup to own an electronic vehicle !<br/>Let our extensive EV charging network charges up your car & your day !',
    searchbyregion: 'SEARCH BY REGION',
    searchbyaddress: 'SEARCH BY ADDRESS',
    searchholder: 'Enter Address...',
    layer1Title: 'FPS - SCAN TO MAKE I-MONTHLY PAYMENT',
    layer1subTitle: 'How to Pay',
    layer1text1: '1.Selected FPS.',
    layer1text2: '[For Desktop User] a QR code will be generated on the screen.',
    layer1text3: '[For Moblie User] please make a screenshot of the QR code.',
    layer1text4: '2. Open the bank‘s app with your mobile phone.',
    layer1text5: 'Select ‘Pay with FPS‘ and login to your selected bank account.',
    layer1text6:
      '[For Desktop User] Use your mobile phone to scan the QR code on your screen and proceed with the payment.',
    layer1text7:
      '[For Moblie User] Upload the saved QR code in your bank‘s app and proceed with the payment.',
    layer2Title: 'ONLINE BOOKING',
    layer2Title1: 'MAKES PARKING EVEN EASIER!',
    layer2sub1: 'i-MONTHLY',
    layer2text1:
      'You can now conveniently find and book a monthly parking anytime, anywhere. To renew and handle ',
    layer2text11:
      'a range of monthly parking services, simply access your online account with a couple of clicks!',
    layer2href1: 'Register now',
    layer2href2: 'EXPLORE MORE',
    layer2sub2: 'i-HOURLY',
    layer2text2:
      'Imagine if you could reserve a parking space for your next meeting, lunch date or errand with just a couple of clicks?',
    layer2text22:
      'Saving you valuable time in your busy day, letting you focus on both work and play.',
    layer2href3: 'Pre-book i-Hourly parking now',
    layer2href4: 'EXPLORE MORE',

    RegionSelector: 'Select Region',
    DistrictSelector: 'Select District',
  },

  MobileApp: {
    Title: 'WILSON PARKING MOBILE APP',
    text1: 'Download the',
    text11: 'Brand-new',
    text12: 'Wilson Parking Mobile App to kick start your smart parking journey !',
    text2:
      'The Wilson Parking Mobile App provides you the smartest and easiest way to access real-time parking info inclusive of spaces availability, parking charges and one-touch navigation to car park entrance! You can now make monthly parking payment for selected car parks anytime, anywhere via',
    text22: 'i-Monthly',
    text23: ' to enjoy greater convenience. With',
    text24: ' Eat & Play',
    text25: ', you can check out the hottest restaurants and events in town.',
    text26: 'Park+Jetso',
    text27:
      ', just as its name implies, provides the best and exclusive parking-plus service offers to our app users.',
    subtext: 'Key Features:',
    text3: 'Car Parks:',
    text33:
      'Instant access to real time parking information – space availability, nearby car parks, car park particulars, parking schemes and rates, one-touch navigation to car park entrance',
    text4: 'Eat & Play:',
    text44: 'Explore and check out restaurants and interesting events nearby',
    text5: 'i-Monthly:',
    text55: 'Book and renew monthly parking service with just a couple of taps',
    text6: 'My Page:',
    text66:
      'Manage monthly parking service, retrieve payment records, update vehicle registration mark, and more',
    text7: 'Park+Jetso:',
    text77:
      'Book exclusive value-for-money car beautification service and parking-plus offers instantly',
  },

  PRIVACYPOLICY: {
    Header: 'PRIVACY POLICY',
    Title1: '< PRIVACY POLICY STATEMENT >',
    T1text1:
      'It is the policy of Wilson Parking (Holdings) Limited, its subsidiaries and associated companies (hereinafter called “the Companies”) to comply with the Personal Data (Privacy) Ordinance, Chapter 486 of the laws of the Hong Kong. The Companies also strive to ensure compliance by our staff with the strictest standards of security and confidentiality.',
    T1text2:
      'The Companies safeguard information provided by its customers and website users. With the only exceptions that personal data may be collected in relation to the services of sign-in / registration of services, account set up, account maintenance, e-payment of the Companies’ products, geo-location and the giving/collection of opinion online and that the IP address of the computer used to visit our website may be recorded, the Companies do not collect any personally identifiable information from users while they browse its sites. When a user visits a website the visit is recorded only as a ‘hit’ and no personal data is collected. This information is used only for preparing general statistics on the usage of our websites.',

    Title2: 'USE OF COOKIES',
    T2text1:
      'We use cookies across our websites in order to improve their performance and enhance your online experience. Session cookies are used to enable you to move around the site and use essential functions on our websites, such as maintaining log-in details for the session such that the need to transfer information across the internet may be reduced. Google Analytics are used to recognize repeat visitors to our websites in order to enable us to better understand how our users browse to and through our websites, the time they spend and how often they visit our websites, relying on which we can improve our websites. Font size cookies are used to provide proper appearance of characters when you browse our websites. We will not collect any personal data from you when the cookies are being used.',
    T2text2:
      'The collection of any personal data collected will be subject to the Companies’ Personal Information Collection Statement. Personal data is stored securely in the Companies’ system and the Companies will take all practicable steps to ensure that personal data is not kept longer than is necessary for the fulfillment of the purpose (including any directly related purpose) for which the data is or is to be used. Only trained, authorized staff shall have access to the data, and the Companies do not release personal data to parties outside the Companies except as set out in the Companies’ Personal Information Collection Statement. Users have the right to request access to and correction of their personal information in accordance with the procedure set out in the Companies’ Personal Information Collection Statement.',
    T2text3:
      'The Companies may, from time to time, send direct marketing materials promoting products and services to users based on their personal data, but suitable opt-out mechanisms are provided.',
    T2text4:
      'The Companies make every effort to protect the privacy of users, but given the nature of the Internet, it cannot guarantee perfect security.',
    T2text5:
      'The Companies use third party content and service providers and offer links to third party websites. These third parties may collect personal data from users and they adhere to their own privacy policies. The Companies’ Privacy Policy Statement and Personal Information Collection Statement do not cover third parties.',
    T2text6:
      'Users who have any questions about the Companies’ privacy policy and practice can contact us at info@wilsonparking.com.hk or by post at Room 2901, Metroplaza Tower 1, Hing Fong Road, Kwai Chung, New Territories.',

    Title3: '< PERSONAL INFORMATION COLLECTION STATEMENT >',
    T3text1:
      'This Personal Information Collection Statement sets out the purposes for which the information provided by you will be used following collection, what you are agreeing to with respect to our use of such information and your rights under the Personal Data (Privacy) Ordinance, Cap 486. This statement may change from time to time, so please check back periodically. Each time a user logs in to this website and uses its services, they agree to be bound by the statement in force at that time.',

    Title4: 'COLLECTION OF DATA',
    T4text1:
      'Users may be asked to provide with personally-identifiable information such as name, phone number, e-mail address, credit card information, etc. This is necessary to provide the users the various services and activities offered on this website. Users are not obliged to supply the data, but if they do not, the services and activities will be unavailable.',
    T4text2: ' IP address of the computer used to visit our web site may be recorded.',

    Title5: 'PURPOSE AND USE OF DATA',
    T5text1: 'Information collected is used for the followings:',
    T5text2: 'monitoring use of the web site to help its further development',
    T5text3: 'compiling aggregate statistics about our users to analyze site usage',
    T5text4:
      'creating accounts for users who intend to register with the services offered on this web site and  maintaining such accounts',
    T5text5:
      'registering membership for users who intend to join the membership and maintenance of the membership',
    T5text6:
      'identifying and verifying identity of the users who used the services offered on this web site',
    T5text7:
      'communicating with the users in respect of matters related to or arising from the use of the services offered on this web site',
    T5text8: 'researches and/or analysis by the Companies',
    T5text9:
      'providing information related to the Companies including the products, facilities, services and other privileges, benefits and other advantages from time to time offered by the Companies or service providers to users',
    T5text10: 'handling and following up enquiries, suggestions, complaints and claims',
    T5text11: 'conducting service surveys to better understand customers’ needs',
    T5text12:
      'better tailor products and services to the needs of our customers and/or the type of information presented to our customers',
    T5text13:
      'We also intend to use your name, contact details and the information as to the goods and services which you were/might be interested in, for delivering information that you may be interested in, such as targeted banners, new services and products and other promotions and marketing materials and conducting direct marketing including products, services, advice and subjects in relation to car parking services. We also intend to, and in this regard you consent to, transfer and provide the abovementioned information to the holding, subsidiaries, associated, or affliliated of, or companies controlled by, or under common control with Wilson Parking (Holdings) Limited and the service providers through whom the Companies’ products, facilities, services, privileges, benefits or advantages are provided inside and outside Hong Kong for the said purpose. We may not so use or provide the said information unless we have received your consent. Your consent may be communicated to us without charge at the time when you provide such information through our website or by writing to us.',

    Title6: 'TRANSFER OF DATA',
    T6text1:
      'User information will not generally be disclosed or transferred to any other party in a form that would identify them except those to parties relevant and reasonably necessary for the purposes stated above.',

    Title7: 'Use of Cookies',
    T7text1:
      'We use cookies across our websites in order to improve their performance and enhance your online experience. Session cookies are used to enable you to move around the site and use essential functions on our websites, such as maintaining log-in details for the session such that the need to transfer information across the internet may be reduced. Google Analytics are used to recognize repeat visitors to our websites in order to enable us to better understand how our users browse to and through our websites, the time they spend and how often they visit our websites, relying on which we can improve our websites. Font size cookies are used to provide proper appearance of characters when you browse our websites. We will not collect any personal data from you when the cookies are being used.',

    Title8: 'ACCESS TO DATA',
    T8text1:
      'Users have the right to request access to and correction of your personal data in accordance with the provisions of the Personal Data (Privacy) Ordinance (Cap.486). Any data access request or data correction request may be made to us at info@wilsonparking.com.hk or by post at Room 2901, Metroplaza Tower 1, Hing Fong Road, Kwai Chung, New Territories.',
    T8text2:
      'Being our valuable customer, we thank you for your continuous support and from time to time we will share with you the latest information about Wilson Parking (Holdings) Limited which might interest you. Should you not wish to receive direct marketing material and/or communications from us, you may exercise your opt-out right by notifying us via e-mail at info@wilsonparking.com.hk or by post at Room 2901, Metroplaza Tower 1, Hing Fong Road, Kwai Chung, New Territories.',
    Title9: '< INFORMATION SECURITY POLICY >',
    T9text1: `Protecting the safety of your information is very important to us. We use Transport Layer Security (TLS) advanced technology to encrypt customer's private information so that it would not be read as the information travels over the Internet. As ‘HTTPS’ will appear in our URL, the details of the security certificate can be viewed by clicking on the lock symbol on the browser bar. For on-line payments, customer will be directed to a third party payment processing service to make secure payment on VISA, MasterCard and PPS. The Company will not have and will not retain credit card information input by the customer at the third party payment processing service platform.'`,
    T9text2: 'For any disputes, English version shall prevail.',
  },

  iMONTHLYTerms: {
    Title: '< TERMS & CONDITIONS OF THE USE OF MONTHLY PARKING SERVICES >',
    Text1:
      'New Purchase or Renewal Patrons of Monthly Parking Service are subject to the ‘Conditions of Parking and Use’ of Wilson Parking (Holdings) Limited (hereinafter referred to as ‘the Company’) displayed at the entrance of the car parks or other terms and conditions displayed on the Company Website (“www.wilsonparking.com.hk”), Mobile App and car parks. Otherwise the Company has the right to terminate the monthly parking services without any compensation.',
    Text2: '1. PURCHASE OF MONTHLY PARKING SERVICE',
    Text3:
      'New purchase of monthly parking service is subject to parking bays availability. Patron can login the Company Website (“www.wilsonparking.com.hk”) or Mobile App to register as a monthly patron and use various designated e-payment means or other designated means (if applicable) to make first month payment.',
    Text4:
      'Purchase of new monthly parking services made: on or before the 15th day of the current month, full month parking service fee shall apply; between the 16th day and the 21st day of the current month, half-month parking service fee shall apply; between the 22nd day and the last day of the current month, half-month parking service fee plus full month parking service fee for the following month shall apply.',
    Text5:
      'During the booking process, the quota for the selected monthly parking service will be reserved and patron has 15 minutes to complete the booking on the Company Website or Mobile App. The quota will be released when either the booking process is cancelled or the process time has exceeded 15 minutes. For online payment, patron will be directed to a third party payment processing service to make secure payment including but not limited to VISA, MasterCard, Faster Payment System (FPS) and PPS. Please note that the Company shall not be liable or responsible for such service and your use of such service may be subject to the terms and conditions imposed by the service providers. The Company does not have and will not retain any payment information input by the patron at the third party payment processing service.',
    Text6:
      'One vehicle registration mark can book for only one monthly parking service at the same car park.',
    Text7:
      'Existing patron can access [ My Account ] on the Company Website or Mobile App to manage personal details and to make renewal payment by various designated e-payment means between the 22nd day and the last day of the current month. The personal data and other related information you provided to us will be used to facilitate the monthly parking services. If the data / information patron provided are inadequate or inaccurate, it will affect the provision of services as stipulated in the Company Website or Mobile App. Patron may view and amend personal data/ information via his account. Timely updating of personal data/ information is important to ensure monthly parking service will not be interrupted unnecessarily.',
    Text8:
      'Patron who wishes to pay monthly parking service fee in cash at any 7-11 convenience store or by cheque through the “Cheque Deposit Machine”(CQM) at HSBC [crossed cheque should be made payable to “Wilson Parking (Holdings) Limited”] must make payment three working days prior to the expiry date.',
    Text9:
      'If the monthly parking service is not renewed before expiry, it will be terminated automatically and the service quota will be released to other patrons. Should patron want to resume the same monthly parking service after termination, patron will have to purchase the monthly parking service as a new monthly parking service and is subject to availability of the monthly parking service at the time of purchase. In addition, vehicle with monthly parking service terminated but still occupying parking bay will be charged according to the casual parking rate of the car park starting from the time the service was terminated.',
    Text10:
      'Once payment for monthly parking service is made, no refund shall be made no matter whether the service is used or not.',
    Text11:
      'Only registered vehicle with valid monthly pass, smart card, remote control, use of contactless parking system or any other designated means is allowed to access/egress the car park.',
    T2Title: '2. VALIDITY OF MONTHLY PARKING SERVICE',
    T2Text:
      'Monthly parking service is valid for the durations purchased. For full month parking service, the validity is from 00:00hr of the first day to 23:59hr of the last day of the same month.',
    T3Title:
      '3. USE OF MONTHLY PARKING SERVICE (Applicable to car parks equipped with Access Control Equipment)',
    T3Text1:
      'A monthly pass, smart card, remote control or other designated identity will be issued to each new patron.',
    T3Text2:
      'If patron fails to gain access or exit by designated means and requests to raise the barrier gate for entering / exiting the car park, registration of patron’s personal data is required and is subject to an administrative charge equivalent to one hour casual parking fee.',
    T3Text3:
      'Upon expiry and termination of monthly parking service, monthly patron shall return the smart card or remote control within three months of termination. Otherwise a non-refundable administration fee of HK$200 will be levied.',
    T3Text4:
      'For loss of or damage to monthly pass, smart card, remote control or designated identity, patron has to pay an administrative fee of HK$200 for re-issuance/replacement/update. Monthly pass, smart card, remote control or designated identity which is reported lost is no longer valid and there shall be no refund or compensation. If the monthly pass, smart card, remote control or designated identity is invalid because of natural wear and tear or failure, it will be replaced without charge.',
    T4Title: '4. CHANGE OF VEHICLE REGISTRATION MARK',
    T4Text1:
      'Monthly parking service is only for use by one registered vehicle for the specified car park within the validity period.',
    T4Text2:
      'Unauthorised use of monthly parking service by any unregistered vehicle will result in termination of the monthly parking service without any compensation and the deposit (if any) will not be refunded.',
    T4Text3:
      'Application for change of vehicle registration mark can be made on a short-term or permanent basis before the new vehicle enters into the specified car park. Change of vehicle registration mark is limited to once a month.',
    T4Text4:
      'Short-term change of vehicle registration mark is allowed for a maximum of 5 consecutive days free of charge. Casual parking fee will be charged for the over-stayed replacement vehicle from the sixth day onwards',
    T4Text5:
      'For permanent change of vehicle registration mark, a non-refundable administration fee of HK$50 is payable. If the permanent change is made during renewal of the monthly parking service, administration fee will be waived.',
    T5Title: '5. OTHER ISSUES',
    T5Text1:
      'Car washing, polishing and repairing are strictly prohibited in any part of the car park.',
    T5Text2:
      'Patron should not leave any items in the car park unattended. The Company reserves the right to remove any unauthorised items in the car park without prior notice.',
    T5Text3: 'Use of fire hose is strictly prohibited except for the purpose of fire fighting.',
    T5Text4:
      'The Company does not guarantee provision of Electric Vehicle Charging Stations and/or Electric Vehicle Chargers and/or Electric Vehicle Charging System for the patron.',
    T5Text5:
      'The Company will not be liable for any losses, claims or damages arising from the malfunction or failure or not yet updated vehicle registration mark or information of car park access control system and/or contactless parking system and/or the malfunction or failure of car lift and/or mechanical parking facilities and/or other facilities.',
    T5Text6: 'The Company will not provide any monthly parking or vehicle entrance/exit record.',
    T5Text7: 'Payment receipt will not be re-issued.',
    T5Text8:
      'Vehicle with valid monthly parking service shall hold a valid vehicle registration document.',
    T5Text9:
      'In view of the nature and specific features of the contactless parking service, in particular the feature of entering or exiting car parks without a designated monthly pass, smart card, remote control or designated identity, patron entering or exiting car parks by the contactless parking service shall take proper safety precautions against loss of or damage to the vehicle and any goods, articles or appliances inside or outside the vehicle. Patrons should ensure effective anti-theft alarm system is in full operation at all times whilst their vehicles remain in the car parks. All other protections provided for the safety of the vehicles shall be maintained in good order and in full operation. All doors to the vehicles should be completely locked when left unattended. All keys and smart keys should be removed when leaving the vehicles and must not be left in the vehicles unattended. The Company will not be liable for any loss of or damage to any vehicle or property (including theft of vehicle) resulting from the use of the contactless parking service.',
    T5Text10:
      'The Company may vary this “Notice to Monthly Patron”, the ‘Conditions of Parking and Use’ or other terms and conditions by altering, adding or deleting any or all of them or making new terms and/or conditions and the new terms and conditions shall be effective and binding on the motor vehicle’s owner and/or user of any motor vehicle and/or monthly patron using the parking services upon posting of such new terms and conditions in a conspicuous place in the car parks, Website and Mobile App.',
    T6Title: '< DELIVERY POLICY >',
    T6Text1:
      '1. New Monthly parking customer will be provided with a monthly pass, smart card, remote control or other designated identity for access to the designated car park. Car park staff will coordinate with customer the time and location for delivery of the monthly pass, smart card, remote control or other designated identity. Courier service can also be arranged for delivery of the monthly pass, smart card, remote control or other designated identity to the customer, which may take at least 2 days.',
    T6Text2:
      '2. For renewal of monthly parking, validity of monthly pass, smart card, remote control or other designated identity will be extended to the last day of the payment month.',
  },

  Region: {
    Select: 'Select Region',
    HongKong: 'Hong Kong',
    Kowloon: 'Kowloon',
    Newterritories: 'New Territories',
  },

  Language: {
    Select: 'Pleace Select',
    zh: 'Traditional Chinese',
    en: 'English',
  },

  Prefix: {
    Select: 'Please Select',
    Mr: 'Mr',
    Mrs: 'Mrs',
    Ms: 'Ms',
  },

  Selector: {
    Region: 'Select Region',
    District: 'Select District',
  },

  Map: {
    'i-Monthly': 'i-Monthly service available',
    'REFINE SEARCH': 'REFINE SEARCH',
    'Search by Address': 'Search by Address',
    'Search by Region': 'Search by Region',
    Region: 'Region',
    District: 'District',
    Directions: 'Directions',
    Phone: 'Phone',
    Reset: 'Reset search',
    search: 'Enter Address...',
    getDirections: 'Get directions from...',
    goolemapOpen: 'OPEN IN GOOGLE MAPS',
    clearDirections: 'CLEAR DIRECTIONS',
  },

  CarParkDetail: {
    PHOTO: 'PHOTO',
    MAP: 'MAP',
    'STREET VIEW': 'STREET VIEW',
    PaymentMethod: 'Payment Method',
    Book: 'BOOK',
    Full: 'FULL',
    Address: 'Address',
    Phone: 'Phone',
    Remark: 'Remark',
    BackToMap: 'BACK TO MAP',
    DistrictCarParks: 'MORE CAR PARKS FROM THIS DISTRICT',
    iHourlyFAQ: 'i-HOURLY TUTORIAL & FAQ',
    iMonthlyFAQ: 'i-MONTHLY TUTORIAL & FAQ',
    Booking: {
      SelectPrompt: 'SELECT MONTHLY PARKING SERVICE PERIOD',
      FromToday: 'Start from today',
      FromTodayHint:
        'To start your parking service from today, you are required to pre-pay monthly parking fee of next month.',
      FromNextMonth: 'Start from next month',
      to: 'to',
      Next: 'NEXT',
      Reserved: 'Reserved',
      NonReserved: 'Non-Reserved',
      errorMsg: 'Service Period Error,Please content customer service!',
    },
    isBookable: 'PLEASE APPROACH CAR PARK OFFICE FOR DETAILS OF APPLICATION',
    Hour12: 'Calculated from time of entry until 24:00 on the same day',
    Hour24: 'Max charge for each 24 hours',
    MaxPark: 'Calculated from time of entry until 24:00 on the same day',
    freeCarParking: 'FREE PARKING: ',
    monthly: 'Monthly Parking',
  },

  Cart: {
    Instructions: {
      Header: 'PLEASE READ CAREFULLY',
      '1-1': `During the booking process, the service will be kept in the cart for 15 minutes. If the transaction is idled over 15 minutes, the selected service will be released from the cart and made available for other customers.`,
      '1-2': `One vehicle registration mark is entitled for one monthly parking service in the
    same car park.`,
      '2-1': `Please carefully check the information below as once your booking is confirmed, 
      it cannot be changed or cancelled.`,
    },
    timeUp: 'The transaction is idled for 15 minutes, please refresh the page or try again. ',
    expired: 'Booking service expired',
    paymentExpired: 'Payment session expired',
    retry: 'Please go back and try again.',
    close: 'Close',
    BackMessage:
      'If you click “BACK”, your selected service will be made available to other customers.',
    EmptyMessage: 'Your cart is currently empty',
    DetailHeader: 'BAY DETAILS',
    BackToService: 'BACK TO MY SERVICE',
    BookMore: 'BOOK MORE',
    Next: 'NEXT',
    Back: 'BACK',
    Confirm: 'CONFIRM',
    Remove: 'Remove',
    ConfirmRemove: 'Are you sure you want to remove the item from cart?',
    ConfirmChange: 'Are you sure you want to change your registration mark?',
    ChangeSuccess: 'SUCCESSFUL',
    contantYou: 'We will contact you for the collection of monthly access card shortly',
    contantAddress: 'Thank you for choosing the Wilson Parking service!',
    BookingTypeTitle: 'Booking Type',
    ServiceTitle: 'Service',
    ServicePeriodTitle: 'Service Period',
    monthlyPeriodTitle: 'Current Month Service Period',
    CarTitle: 'Assigned Car',
    ChangeCar: 'Change',
    RemoveCar: 'Remove Car',
    Price: 'Price',
    ServiceFee: 'Service Fee',
    HandlingFee: 'Handling Fee',
    Summary: 'SUMMARY',
    IMonthly: {
      step1Title: 'CHANGE OF REGISTRATION MARK',
      changeLPNDescription:
        'Application for change of vehicle registration mark must be made one hour before the new vehicle enters into the specified car park. Vehicle entering the car park without completion of change of the vehicle registration mark has to pay casual parking fee according to the duration of parking.',
      step1Text1:
        'Change of vehicle registration mark is limited to once a calendar month either on permanent or short-term basis.',
      step1Text2:
        'Permanent change of vehicle registration mark is subject to a non-refundable administration fee of HK$50.',
      step1Text3:
        'Short-term change of vehicle registration mark is allowed for a maximum of 5 consecutive days free of charge. Casual parking fee will be charged for the over-stayed replacement vehicle from the 6th day onwards.',
      step1Text4:
        'When applying for change of vehicle registration mark, both the newly registered vehicle and the original registered vehicle shall not be inside the car park.',
      step1Text5: 'The updated vehicle must be the same type of vehicle.',
      iParkRemarks:
        'Please update your car info for iPark under ‘Manage Vehicles’ in Wilson Parking App if you are an iPark user',
      stlectType: 'Select Type of Change',
      temporary: 'Temporary change (Free of charge, maximum of 5 days use, effective from today)',
      permanent: 'Permanent change (HK$50 admin fee wil be levied)',
      VRH: 'Vehicle Registration Mark',
      newVRH: 'New Vehicle Registration Mark',
      startDate: 'Start Date',
      endDate: 'End Date',
      today: 'Today',
      step2Title: 'ASSIGNED CAR CHANGING DETAILS',
      originalVRH: 'ORIGINAL ASSIGNED CAR',
      new: 'New ASSIGNED CAR',
      fee: 'ADMINISTRATION FEE',
      choose: 'CHOOSE A PAYMENT METHOD',
      all: 'All transactions will be processed in Hong Kong Dollars (HK$).',
    },
    PickUpMethod: {
      Prompt: 'CHOOSE PARK泊CARD PICK-UP METHOD',
      Title: 'Pick-up Method',
      Self: 'Self Pick-up',
      Courier: 'Courier',
      LocationPrompt: 'Pick-up Location',
    },
    PaymentMethod: {
      ChoosePrompt: 'CHOOSE A PAYMENT METHOD',
      HKDDisclaimer: 'All transactions will be processed in Hong Kong Dollars (HK$).',
      'VISA/MasterCard': 'Pay by VISA / Mastercard',
      PPS: 'Pay by PPS',
      FPS: 'Pay by FPS',
      Cheque: 'Cheque',
      SavedCard: 'Saved Payment Methods (Credit Card)',
      NewCard: 'Use Other Credit Card',
      '7-11': '7-11',
    },
    TnC: {
      Title: 'Terms and Conditions',
      Content: `<p><span style="text-decoration: underline;">&lt; TERMS &amp; CONDITIONS OF THE USE OF MONTHLY PARKING SERVICES &gt;</span></p><p><span style="text-decoration: underline;"><br /></span>New Purchase or Renewal Patrons of Monthly Parking Service are subject to the &lsquo;Conditions of Parking and Use&rsquo; of Wilson Parking (Holdings) Limited (hereinafter referred to as &lsquo;the Company&rsquo;) displayed at the entrance of the car parks or other terms and conditions displayed on the Company Website(&ldquo;www.wilsonparking.com.hk&rdquo;), Mobile App and car parks. Otherwise the Company has the right to terminate the monthly parking services without any compensation.</p><p>&nbsp;</p><p>1. PURCHASE OF MONTHLY PARKING SERVICE</p><p>&nbsp;</p><p>-New purchase of monthly parking service is subject to parking bays availability. Patron can login the Company Website (&ldquo;www.wilsonparking.com.hk&rdquo;) or Mobile App to register as a monthly patron and use various designated e-payment means or other designated means (if applicable) to make first month payment.</p><p>&nbsp;</p><p>-Purchase of new monthly parking services made: on or before the 15th day of the current month, full month parking service fee shall apply; between the 16th day and the 21st day of the current month, half-month parking service fee shall apply; between the 22nd day and the last day of the current month, half-month parking service fee plus full month parking service fee for the following month shall apply.</p><p>&nbsp;</p><p>-During the booking process, the quota for the selected monthly parking service will be reserved and patron has 15 minutes to complete the booking on the Company Website or Mobile App. The quota will be released when either the booking process is cancelled or the process time has exceeded 15 minutes. For online payment, patron will be directed to a third party payment processing service to make secure payment including but not limited to VISA, MasterCard, Faster Payment System (FPS) and PPS. Please note that the Company shall not be liable or responsible for such service and your use of such service may be subject to the terms and conditions imposed by the service providers. The Company does not have and will not retain 
any payment information input by the patron at the third party payment processing service.</p><p>&nbsp;</p><p>-One vehicle registration mark can book for only one monthly parking service at the same car park.</p><p>&nbsp;</p><p>-Existing patron can access [ My Account ] on the CompanyWebsite or Mobile App to manage personal details and to make renewal payment by various designated e-payment means between the 22nd day and the last day of the current month. The personal data and other related information you provided to us will be used to facilitate the monthly parking services. If the data / information patron provided are inadequate or inaccurate, it will affect the provision of services as stipulated in the Company Website or Mobile App. Patron may view and amend personal data/ information via his account. Timely updating of personal data/ information is important to ensure monthly parking service will not be interrupted unnecessarily.</p><p>&nbsp;</p><p>-Patron who wishes to pay monthly parking service fee in cash at any 7-11 convenience store or by cheque through the &ldquo;Cheque Deposit Machine&rdquo;(CQM) at HSBC [crossed cheque should be made payable to &ldquo;Wilson Parking (Holdings) Limited&rdquo;] must make payment three working days prior to the expiry date.</p><p>&nbsp;</p><p>-If the monthly parking service is not renewed before expiry, it will be terminated automatically and the service quota will be released to other patrons. Should patron want to resume the same monthly parking service after termination, patron will have to purchase the monthly parking service as a new monthly parking service and is subject to availability of the monthly parking service at the time of purchase. In addition, vehicle with monthly parking service terminated but still occupying parking bay will be charged according to the casual parking rate of the car park starting from the time the service was terminated.</p><p>&nbsp;</p><p>-Once payment for monthly parking service is made, no refund shall be made no matter whether the service is usedor not.</p><p>&nbsp;</p><p>-Only registered vehicle with valid monthly pass, smart card, remote control, use of contactless parking system or any other designated means is allowed to access/egress the car park.</p><p>&nbsp;</p><p>&nbsp;</p><p>2. VALIDITY OF MONTHLY PARKING SERVICE</p><p>&nbsp;</p><p>-Monthly parking service is valid for the durations purchased. For full month parking service, the validity is from 00:00hr of the first day to 23:59hr of the last day of the same month.</p><p>&nbsp;</p><p>&nbsp;</p><p>3. USE OF MONTHLY PARKING SERVICE (Applicable to car parks equipped with Access Control Equipment)</p><p>&nbsp;</p><p>-A monthly pass, smart card, remote control or other designated identity will be issued to each new patron.</p><p>&nbsp;</p><p>-If patron fails to gain access or exit by designated means and requests to raise the barrier gate for entering / exiting the car park, registration of patron&rsquo;s personal data is required and is subject to an administrative charge equivalent to one hour casual parking fee.</p><p>&nbsp;</p><p>-Upon expiry and termination of monthly parking service, monthly patron shall return the smart card or remote control within three months of termination. Otherwise a non-refundable administration fee of HK$200 will be levied.</p><p>&nbsp;</p><p>-For loss of or damage to monthly pass, smart card, remote control or designated identity, patron has to pay an administrative fee of HK$200 for re-issuance/replacement/update. Monthly pass, smart card, remote control or designated identity which is reported lost is no longer valid and there shall be no refund or compensation. If the monthly pass, smart card, remote control or 
designated identity is invalid because of natural wear and tear or failure, it will be replaced without charge.</p><p>&nbsp;</p><p>&nbsp;</p><p>4. CHANGE OF VEHICLE REGISTRATION MARK</p><p>&nbsp;</p><p>-Monthly parking service is only for use by one registered vehicle for the specified car park within the validity period.</p><p>&nbsp;</p><p>-Unauthorised use of monthly parking service by any unregistered vehicle will result in termination of the monthly parking service without any compensation and the deposit (if any) will not be refunded.</p><p>&nbsp;</p><p>-Application for change of vehicle registration mark can be made on a short-term or permanent basis before the new vehicle enters into the specified car park. Change of vehicle registration mark is limited to once a month.</p><p>&nbsp;</p><p>-Short-term change of vehicle registration mark is allowed for a maximum of 5 consecutive days free of charge. Casual parking fee will be charged for the over-stayed replacement vehicle from the sixth day onwards.</p><p>&nbsp;</p><p>-For permanent change of vehicle registration mark, a non-refundable administration fee of HK$50 is payable. If the permanent change is made during renewal of the monthly parking service, administration fee will be waived.</p><p>&nbsp;</p><p>&nbsp;</p><p>5. OTHER ISSUES</p><p>&nbsp;</p><p>-Car washing, polishing and repairing are strictly prohibited in any part of the car park.</p><p>&nbsp;</p><p>-Patron should not leave any items in the car park unattended. The Company reserves the right to remove any unauthorised items in the car park without prior notice.</p>
<p>&nbsp;</p><p>-Use of fire hose is strictly prohibited except for the purpose of fire fighting.</p><p>&nbsp;</p><p>-The Company does not guarantee provision of Electric Vehicle Charging Stations and/or Electric Vehicle Chargers and/or Electric Vehicle Charging System for the patron.</p><p>&nbsp;</p><p>-The Company will not be liable for any losses, claims or damages arising from the malfunction or failure or not yet updated vehicle registration mark or information of car park access control system and/or contactless parking system and/or the malfunction or failure of car lift and/or mechanical parking facilities and/or other facilities.</p><p>&nbsp;</p><p>-The Company will not provide any monthly parking or vehicle entrance/exit record.</p><p>&nbsp;</p><p>-Payment receipt will not be re-issued.</p><p>&nbsp;</p><p>-Vehicle with valid monthly parking service shall hold a valid vehicle registration document.</p><p>&nbsp;</p><p>-In view of the nature and specific features of the contactless parking service, in particular the feature of entering or exiting car parks without a designated monthly pass, smart card, remote control or designated identity, patron entering or exiting car parks by the contactless parking service shall take proper safety precautions against loss of or damage to the vehicle and any goods, articles or appliances inside or outside the vehicle. Patrons should ensure effective anti-theft alarm system is in full operation at all times whilst their vehicles remain in the car parks. All other protections provided for the safety of the vehicles shall be maintained in good order and in full operation. All doors to the vehicles should be completely locked when left unattended. All keys and smart keys should be removed when leaving the vehicles and must not be left in the vehicles unattended. The Company will not be liable for any loss of or damage to any vehicle or property (including theft of vehicle) resulting from the use of the contactless parking service.</p>
<p>&nbsp;</p><p>-The Company may vary this &ldquo;Notice to Monthly Patron&rdquo;, the &lsquo;Conditions of Parking and Use&rsquo; or other terms and conditions by altering, adding or deleting any or all of them or making new terms and/or conditions and the new terms and conditions shall be effective and binding on the motor vehicle&rsquo;s owner and/or user of any motor vehicle and/or monthly patron using the parking services upon posting of such new terms and conditions in a conspicuous place in the car parks, Website and Mobile App.</p><p>&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration: underline;">&lt; DELIVERY POLICY &gt;</span></p><p>&nbsp;</p><p>1. New Monthly parking customer will be provided with a monthly pass, smart card,remote control or other designated identity for access to the designated car park. Car park staff will coordinate with customer the time and location for delivery of the monthly pass, smart card, remote control or other designated identity. Courier service can also be arranged for delivery of the monthly pass, smart card, remote control or other designated identity to the customer, which may take at least 2 days.</p><p>&nbsp;</p><p>2. For renewal of monthly parking, validity of monthly pass, smart card, remote control or other designated identity will be extended to the last day of the payment month.</p><p>&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">&lt; PRIVACY POLICY STATEMENT &gt;</span></p><p>&nbsp;</p><p>1.&nbsp;It is the policy of Wilson Parking (Holdings) Limited, its subsidiaries and associated companies (hereinafter called &ldquo;the Companies&rdquo;) to comply with the Personal Data (Privacy) Ordinance, Chapter 486 of the laws of the Hong Kong. The Companies also strive to ensure compliance by our staff with the strictest standards of security and confidentiality.</p>
<p>&nbsp;</p><p>2. The Companies safeguard information provided by its customers and website users. With the only exceptions that personal data maybe collected in relation to the services of membership application, membership renewal, membership/account maintenance, email registration, e-payment of the Companies&rsquo; products, geo-location and the giving/collection of opinion online and that the IP address of the computer used to visit our website may be recorded, the Companies do not collect any personally identifiable information from users while they browse its sites. When a user visits a website the visit is recorded only as a &lsquo;hit&rsquo;and no personal data is collected. This information is used only for preparing general statistics on the usage of our websites.&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">USE OF COOKIES</span></p><p>&nbsp;</p><p>We use cookies across our websites in order to improve their performance and enhance your online experience. Session cookies are used to enable you to move around the site and use essential functions on our websites, such as maintaining log-in details for the session such that the need to transfer information across the internet may be reduced. Google Analytics are used to recognize repeat visitors to our websites in order to enable us to better understand how our users browse to and through our websites, the time they spend and how often they visit our websites, relying on which we can improve our websites. Font size cookies are used to provide proper appearance of characters when you browse our websites. We will not collect any personal data from you when the cookies are being used.</p><p>&nbsp;</p><p>The collection of any personal data collected will be subject to the Companies&rsquo; Personal Information Collection Statement. Personal data is stored securely in the Companies&rsquo; system and the Companies will take all practicable steps to ensure that personal data is not kept longer than is necessary for the fulfillment of the purpose (including any directly related purpose) for which the data is or is to be used. Only trained, authorized staff shall have access to the data, and the Companies do not release personal data to parties outside the companies except as set out in the Companies&rsquo; Personal Information Collection Statements. Users have the right to request access to and correction of their 
personal information in accordance with the procedure set out in the Companies&rsquo; Personal Information Collection Statements.</p><p>&nbsp;</p><p>The Companies may, from time to time, send direct marketing materials promoting products and services to users based on their personal data, but suitable opt-out mechanisms are provided.</p><p>&nbsp;</p><p>The Companies make every effort to protect the privacy of users, but given the nature of the Internet, it cannot guarantee perfect security.</p><p>&nbsp;</p><p>The Companies use third party content and service providers and offer links to third party web sites. These third parties may collect personal data from users and they adhere to their own privacy policies. The Companies&rsquo; Privacy Policy Statement and Personal Information Collection Statement do not cover third parties.</p><p>&nbsp;</p><p>Users who have any questions about the Companies&rsquo; privacy policy and practice can contact us at&nbsp;<span style="text-decoration: underline;">info@wilsonparking.com.hk</span>&nbsp;or by post at Room 2901, Metroplaza Tower 1, Hing Fong Road, Kwai Chung, New Territories.</p><p>&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration: underline;">&lt; PERSONAL INFORMATION COLLECTION STATEMENT &gt;</span></p><p>&nbsp;</p><p>This Personal Information Collection Statement sets out the purposes for which the information provided by you will be used following collection, what you are agreeing to with respect to our use of such information and your rights under the Personal Data (Privacy) Ordinance, Cap 486. This statement may change from time to time, so please check back periodically. Each time a user logs in to this web site and uses its services, they agree to be bound by the statement in force at that time.</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">COLLECTION OF DATA</span></p><p>&nbsp;</p>
<p>Users may be asked to provide with personally-identifiable information such as name, phone number, e-mail address, credit card information, etc. This is necessary to provide the users the various services and activities offered on this website. Users are not obliged to supply the data, but if they do not, the services and activities will be unavailable.</p><p>&nbsp;</p><p>IP address of the computer used to visit our web site may be recorded.</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">PURPOSE AND USE OF DATA</span></p><p>&nbsp;</p><p>Information collected is used for the followings:</p><p>&nbsp;</p><p>-monitoring use of the web site to help its further development</p><p>&nbsp;</p><p>-compiling aggregate statistics about our users to analyze site usage</p><p>&nbsp;</p><p>-creating accounts for users who intend to register with the services offered on this web site and&nbsp; maintaining such accounts</p><p>&nbsp;</p><p>-registering membership for users who intend to join the membership and maintenance of the membership</p><p>&nbsp;</p><p>-identifying and verifying identity of the users who used the services offered on this web site</p><p>&nbsp;</p><p>-communicating with the users in respect of matters related to or arising from the use of the services offered on this web site</p><p>&nbsp;</p><p>-researches and/or analysis by the Companies</p><p>&nbsp;</p><p>-providing information related to the Companies including the products, facilities, services and other privileges, benefits and other advantages from time to time offered by the Companies or service providers to users</p>
<p>&nbsp;</p><p>-handling and following up enquiries, suggestions, complaints and claims</p><p>&nbsp;</p><p>-conducting service surveys to better understand customers&rsquo; needs</p><p>&nbsp;</p><p>-better tailor products and services to the needs of our customers and/or the type of information presented to our customers</p><p>&nbsp;</p><p>We also intend to use your name, contact details and the information as to the goods and services which you were/might be interested in, for delivering information that you may be interested  in, such as targeted banners, new services and products and other promotions and marketing materials and conducting direct marketing including products, services, advice and subjects in relation to car parking services. We also intend to, and in this regard you consent to, transfer and provide the above mentioned information to the holding, subsidiaries, associated, or affliliated of, or companies controlled by, or under common control with Wilson Parking (Holdings) Limited and the service providers through whom the Companies&rsquo; products, facilities, services, privileges, benefits or advantages are provided inside and outside Hong Kong for the said purpose. We may not so use or provide the said information unless we have received your consent. Your consent may be communicated to us without charge at the time when you provide such information through our website or by writing to us.</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">TRANSFER OF DATA</span></p><p>&nbsp;</p><p>User information will not generally be disclosed or transferred to any other party in a form that would identify them except those to parties relevant and reasonably necessary for the purposes stated above.</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">USE OF COOKIES</span></p><p>&nbsp;</p><p>We use cookies across our websites in order to improve their performance and enhance your online experience. Session cookies are used to enable you to move around the site and use essential functions on our websites, such as maintaining 
log-in details for the session such that the need to transfer information across the internet may be reduced. Google Analytics are used to recognize repeat visitors to our websites in order to enable us to better understand how our users browse to and through our websites, the time they spend and how often they visit our websites, relying on which we can improve our websites. Font size cookies are used to provide proper appearance of characters when you browse our websites. We will not collect any personal data from you when the cookies are being used.</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">ACCESS TO DATA</span></p><p>&nbsp;</p><p>Users have the right to request access to and correction of your personal data in accordance with the provisions of the Personal Data (Privacy) Ordinance (Cap.486). Any data access request or data correction request may be made to us at&nbsp;<span style="text-decoration: underline;">info@wilsonparking.com.hk</span>&nbsp;or by post at Room 2901, Metroplaza Tower 1, Hing Fong Road, Kwai Chung, New Territories.</p><p>&nbsp;</p><p>Being our valuable customer, we thank you for your continuous support and from time to time we will share with you the latest information about Wilson Parking (Holdings) Limited which might interest you. Should you not wish to receive direct marketing material and/or communications from us, you may exercise your opt-out right by notifying us via e-mail at&nbsp;<span style="text-decoration: underline;">info@wilsonparking.com.hk</span>&nbsp;or by post at Room 2901, Metroplaza Tower 1, Hing Fong Road, Kwai Chung, New Territories.</p><p>&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration: underline;">&lt; INFORMATION SECURITY POLICY &gt;</span></p><p>&nbsp;</p><p>Protecting the safety of your information is very important to us. We use Transport Layer Security (TLS) advanced technology to encrypt customer's private information so that it would not be read as the information travels over the Internet. As &lsquo;HTTPS&rsquo; will appear in our URL, the details of the security certificate can be viewed by clicking on the lock symbol on the browser bar. For on-line 
payments, customer will be directed to a third party payment processing service to make secure payment on VISA, MasterCard and PPS. The Company will not have and will not retain credit card information input by the customer at the third party payment processing service platform.</p><p>&nbsp;</p><p>For any disputes, English version shall prevail.</p><p>&nbsp;</p>`,
      Agree: 'I agree and accept the Terms and Conditions',
    },
    Discount: 'DISCOUNT CODE',
    Apply: 'APPLY',
    SubTotal: 'Sub-Total',
    BookingTypes: {
      New: 'New',
      Renew: 'Renew',
      Change: 'Change',
    },
    TotalPrice: 'Total Price',
    Steps: {
      Step1: 'FILL IN DETAILS',
      Step2: 'CONFIRM DETAILS',
      Step3: 'PAYMENT',
      Step4: 'COMPLETION',
    },
    ProgressBar: {
      Title: 'CART',
      Tutorial: 'TUTORIAL & FAQ',
      ContactUs: 'CONTACT US',
    },
    CarRecord: {
      title: 'Car Record',
      carType: 'Car Type ',
      VRH: 'Vehicle Registration Mark ',
      fillError: 'Please fill in everything',
      addCar: 'Add more car',
      create: 'Create',
      invalidLPN: 'Plese input valid Vehicle Registration Mark',
    },
    FPS: {
      forMobile: '[For Mobile User] Please make a screenshot of this QR code.',
      text1: 'Open the bank’s app with your mobile phone',
      text2: `Select 'Pay with FPS' and login to your selected bank account.`,
      text3: '[For Mobile User] Upload the saved QR code screenshot, and proceed with the payment.',
      text4:
        '[For Desktop User] Use your mobile phone to scan this QR code, and proceed with the payment.',
      complete: 'COMPLETE PAYMENT',
      back: 'BACK TO HOME PAGE',
      onlyPeriod: 'For {{period}} Monthly Service',
    },
    PPS: {
      read: 'PLEASE READ CAREFULLY:',
      text1: 'Your order is being processed. Please wait...',
      text2: 'The booking process is not complete, please do not close this browser.',
      text3: 'Please settle the payment in the payment gateway pop-up.',
    },
    locationPickupError: 'Please select location.',
    timeupTitle: 'Booking service expired',
    timeupText1:
      ' Since you’ve left your transaction idled for 15 minutes, your selected services are now released from the cart to be made available for other customers.',
    timeupText2:
      'Please go back and book your desired service should you wish to go through the transaction again.',
    Separate:
      'The carparks selected cannot checkout simultaneously, please remove item(s) and try again.',
    support: 'Supported Payment Methods',
    expiredItemRemind:
      'Your selected parking period is invalid and will be removed. Please select again.',
    multipleReminder:
      'You have more than one service item in your cart. Please check all service items carefully before you proceed payment.',
    existingBooking:
      'The registration mark selected is a registered monthly parking vehicle in this car park. Please re-select.',
    pleasePress: 'If you have any problems when entering or leaving car park, please press',
    atTheEntry: 'at the entry / exit machine for assistance.',
    locationText1: 'MONTHLY SERVICE ARRANGEMENT',
    locationText2:
      'Upon successful payment, we will contact you shortly for the monthly service arrangement.',
  },
  Timer: {
    TimeLeft: 'Time Left',
  },
  IhourlyCart: {
    Title: 'BOOK i-HOURLY',
    DetailTitle: 'PLEASE READ CAREFULLY:',
    DetailText1: '1.Booking will remain valid for 1 hour from the pre-booked entry time.',
    DetailText2:
      '2. Parking charges and HK$1 handling fee shall apply.(The handling fee will now be waived during the promotion period)',
    Region: 'Region',
    District: 'District',
    Carpark: 'Car Park',
    Name: 'Name',
    Type: 'Car Type',
    Prefix: 'Prefix',
    FirstNameEng: 'First Name (Eng)',
    LastNameEng: 'Last Name (Eng)',
    Email: 'Email',
    Phone: 'Mobile Number',
    VehicleRegistrationMark: 'Vehicle Registration Mark',
    Date: 'DATE & TIME',
    EntryDate: 'Entry Date ',
    EntryDateinfo: 'Entry Date should be between',
    EntryDateinfo1: 'to',
    EntryDateinfo2: '',
    EntryTime: 'Entry Time',
    EntryTimeinfo: '24 hours advance booking is required',
    CustomerDetails: 'Customer Details',
    SignBoxTitle: 'i-MONTHLY PARKER SIGN IN',
    SignBoxText: 'Save time by logging in here',
    Username: 'Username',
    Password: 'Passwrod',
    Login: 'SIGN IN',
    EntryHourError: 'Invalid Entry Hour.',
    EntryMinsError: 'Invalid Entry Minute.',
    EntryDateError: 'Invalid Entry Date.',
    LoginError: 'Please enter valid login details.',
    StepText1:
      '1.Please carefully check the information below as once your booking is confirmed, it cannot be cancelled or refunded.',
    StepText2:
      '2.Below parking rate is for reference only, the actual parking charges shall refer to the parking rate upon parking, please note the Parking Rate displayed at the entrance of car park.',
    Hourly: 'HOURLY (PER HOUR)',
    Service: 'SERVICE',
    Time: 'TIME',
    ParkingRate: 'PARKING RATE',
    DateTime: 'Date & Time',
    PaymentTitle: 'PAYMENT',
    HandlingFree: 'Handling Fee: HK$1',
    HandlingFreeText: 'Actual parking fee will be settled when user check out at car park.',
    PaymentMethodText: 'All transactions will be processed in Hong Kong Dollars (HK$).',
    OtherMethod: 'Alternative Payment:',
    VisaText:
      'This payment method will be saved securely and used for next transaction, you can remove your saved payment method in "My Profile" later.',
    Terms: 'Terms And Conditions',
    Visa: 'Pay by VISA/MasterCard',
    PPS: 'Pay by PPS',
    FPS: 'Pay by FPS',
    SavedPayment: 'Saved Payment Methods (Credit Card)',
    OtherCard: 'Use Other Credit Card',
    Next: 'NEXT',
    Back: 'BACK',

    TermsTitle1: 'i-MONTHLY',
    iMonthlyT1:
      'Use of i-Monthly parking services or other parking services are subjected to the ‘Conditions of Parking and Use’ of Wilson Parking (Holdings) Limited (hereinafter referred to as ‘the Company’) displayed at the entrance of the car parks or other terms and conditions displayed on our website, app and car parks.',
    iMonthlyT2:
      'The Company may vary the ‘Conditions of Parking and Use’ or other terms and conditions by altering, adding to or deleting any or all of them or making new terms and/or conditions and the new terms and conditions shall be effective and binding on the owner, user of any motor vehicle and/or customer using the parking services upon posting of such new terms and conditions in a conspicuous place at the car parks, website and app.',
    iMonthlyT3:
      'Customer may book for new parking service subjected to availability at the selected car park. If there is no availability for the car park and/or parking service selected, please try selecting an alternative parking service or car park. For booking of new parking service made on or before 15th of the current month, full month parking fee shall apply. For booking made between 16th to the last day of the current month, half-month parking fee shall apply. During the booking process, the quota for the selected parking service will be reserved and customer has 15 minutes to complete the booking. The quota will be released when either the booking process is cancelled or the process time has exceeded 15 minutes. For booking of reserved parking service, the available parking space will be advised by our staff once the booking is completed. New Park泊Card will be issued for each new parking service booked and customer may choose either to pick up in person at designated locations or to receive the new Park泊Card via delivery service. Existing customer may also utilize the same Park泊Card that he/she is currently using if the new parking service is booked for the same vehicle but at different car park(s).',
    iMonthlyT4:
      'One vehicle registration mark can book for only one parking service at the same car park. Parking service is valid from 00:00hr of the first day of each month to 24:00hr of the last day of each month.',
    iMonthlyT5:
      'Customer can renew existing parking service for the next month between 22nd and the last day of the current month. If the parking service is not renewed upon expiry, it will be terminated automatically and the parking service quota will be released to other customer. Should customer want to resume the same parking service after termination; customer will have to book the parking service as new service and is subjected to availability of the parking service at time of booking. Renewal of parking service for more than one month is not allowed.',
    iMonthlyT6: 'Customer may terminate parking service any time prior to the expiry date.',
    iMonthlyT7:
      'All transactions will be processed in Hong Kong Dollars (HK$) and we accept VISA, MasterCard and PPS for online payment. Alternatively, customer may pay at 7-11 stores or via bill payment service through HSBC Cheque Deposit Machines. For online payment, customer will be directed to a third party payment processing service to make secure payment on VISA, MasterCard and PPS. Please be aware the Company will not be liable or responsible for such service and your use of that service might be subject to the terms and conditions imposed by the service provider. The Company will not have and will not retain any payment information input by the customer at the third party payment processing service.',
    iMonthlyT8:
      'Parking service is only for use by the registered vehicle for the specified car park at the time of booking. Unauthorised use of parking service by other vehicle will result in termination of the parking service without compensation and the deposit (if any) will not be refunded. Online application for change of vehicle registration mark is available to customer and the change can be on a temporary basis or permanent basis. For temporary change, a maximum of 5 days is allowed and will not attract an administration fee. However if the temporary change is more than 5 days, casual parking fee will be charged for the replacement vehicle from the sixth day and thereafter. Customer can only apply once per calendar month for such change. For permanent change, an administration fee of HK$50 is payable if the change is made after the parking service has commenced. If the change is made during renewal of the parking service, no administration fee is applicable.',
    iMonthlyT9:
      'The personal data and other related information you provided to us will be used to facilitate the i-Monthly parking services. If the data / information customer provided are inadequate or inaccurate, it will affect the provision of services as stipulated in this website or app. Customer may view and amend personal data/ information via their i-Monthly account. Timely updating of personal data/ information is important to ensure parking service will not be interrupted unnecessarily.',
    iMonthlyT10:
      'Customer should use the valid Park泊Card to enter / exit the car park. If customer requested to raise the barrier gate for exiting the car park, registration of customer’s personal data is required and is subject to an administrative charge equivalent to one hour casual parking fee.',
    iMonthlyT11: 'Once payment for parking service is made, no refund will be made.',
    iMonthlyT12:
      'For loss of Park泊Card or Park泊Card is purposely damaged, customer has to pay an administrative fee of HK$200 for replacement. Park泊Card which is reported lost is no longer valid and cannot be used for any kind of refund, claim or compensation. If a Park泊Card is invalid because of natural wear and tear or magnetic tape failure, it will be replaced without charge.',
    iMonthlyT13:
      'Upon expiry and termination of parking service, customer shall return the Park泊Card to the Company otherwise a non-refundable administration fee of HK$200 will be levied.',
    iMonthlyT14:
      'Car washing, polishing and repairing are strictly prohibited in any part of the car park.',
    iMonthlyT15:
      'Customer should not leave any items in the car park. The Company reserves the right to remove any unauthorized items in the car park without prior notice.',
    iMonthlyT16: 'Use of fire hose is strictly prohibited except for the purpose of fire fighting.',

    TermsTitle2: 'i-HOURLY',
    iHourlyT1: 'Booking can be made at least 24 hours in advance.',
    iHourlyT2:
      'Booking will remain valid for 1 hour from the pre-booked entry time and our car park staff will reserve a suitable parking area for you.',
    iHourlyT3: 'Car Park’s Conditions of Parking and Use shall apply.',
    iHourlyT4: 'Handling fee is not refundable.',
    iHourlyT5:
      'Attentive service will be provided by our car park staff upon your arrival at the car park.',

    TermsTitle3: 'DELIVERY POLICY',
    DELIVERYT1:
      'New Monthly parking customer will be provided with a Park泊Card for access to the chosen car park. Car park staff will coordinate with customer the time and location for delivery of the Park泊Card . Courier service can also be arranged for delivery of the Park泊Card to the customer, which may take at least 2 days.',
    DELIVERYT2:
      'For renewal of monthly parking, validity of Park泊Card will be extended to the last day of the payment month.',
    DELIVERYT3:
      'For i-Hourly booking, our car park staff will assist you when you arrive at the car park.',

    TermsTitle4: 'REFUND',
    REFUNDT1: 'Once payment for parking service is made, no refund will be made.',

    isAgree: 'I agree and accept the Terms and Conditions.',

    SuccessTitle: 'BOOKING SUCCESSFUL',
    SuccessNumber: 'Your reference number is:',
    SuccessFee: 'Booking Fee:',
    SuccessT1: 'Thank you for choosing Wilson Parking, you will receive an email confirmation.',
    SuccessT2: 'Attentive service will be provided by our staff upon your arrival at the car park.',
    SuccessRemark: 'REMARKS:',
    SuccessR1:
      'Booking will remain valid for 1 hour from the pre-booked entry time and our car park staff will reserve a suitable parking area for you.',
    SuccessR2: 'Handling fee is not refundable.',
    SuccessR3: 'Normal hourly parking rates will apply from your time of entry.',
    SuccessR4: 'Car Park’s Conditions of Parking and Use shall apply.',
    SuccessR5: 'For enquiry, please email us at',
    HKD: 'HK$',
    HKD1: '',

    ErrorMsg: 'Please agree and accept the Terms and Conditions.',
    sevenSuccess:
      'Thank you for choosing Wilson Parking, you will receive a SMS/email confirmation.',
  },
  BookingService: {
    isReserved: 'Reserved',
    isNotReserved: 'Non-Reserved',
  },
  PaymentRecords: {
    status: 'Status',
    vehicleRegistrationMark: 'Vehicle Registration Mark',
    carPark: 'Car Park',
    paymentRefNo: 'Payment Ref No.',
    paymentDate: 'Payment date',
    paymentMethod: 'Payment Method',
    tempChange: 'Temporary change of vehicle registration mark',
    permChange: 'Permanent change of vehicle registration mark',
    iMonthly: 'i-Monthly',
    renew: 'Renew',
    '7-11': '7-11',
    cheque: 'Cheque',
    changeCar: 'Change Car',
  },
  IPark: {
    addVehicle: 'ADD VEHICLE',
    activate: 'Activate',
    carType: 'Car Type ',
    VRH: 'Vehicle Registration Mark ',
    fillError: 'Please fill in everything',
    addCar: 'Add more car',
    add: 'Add',
    select: 'Select',
    selectFrom: 'Select from my previous records',
    changeVer: 'Change Verification Method',
    pleaceUseOctopus: 'Please use below octopus card to enter and exit any',
    pleaceUseCredit: 'Please use below credit card to enter and exit any',
    iParkSupport: 'iPark supported car parks',
    once: 'once to activate the service',
    step2Title: 'Register an Octopus Card to activate iPark',
    stepText:
      'Input the 8-digit serial number on the back of your Octopus CardExclude the number in bracket (if any)',
    step2CardTitle: 'Please validate your credit in the popup window',
    step2CardText: 'Click here if the popup window is not shown automatically',
    octopusError: 'Please enter first 8 digits of your Octopus Card No.',
    secure: 'Secure payment',
    card: 'Card Number',
    expiration: 'Expiration',
    cvv: 'CVV',
    authorize: 'Authorize',
    cancel: 'Cancel',
    name: 'Wilson Parking',
    cardError: ' Invalid card number',
  },
  IParkVerifySteps: {
    title: 'ACTIVATE IPARK CONTACTLESS PARKING',
    step1: 'VERIFICATION METHOD',
    step2: 'VERIFICATION INFO',
    step3: 'INSTRUCTIONS',
    select: 'SELECT VERIFICATION METHOD',
    octopus: 'OCTOPUS CARD',
    creditCard: 'CREDIT CARD',
    back: 'BACK',
    next: 'NEXT',
    PPS: 'PPS',
    FPS: 'FPS',
    '7-11': 'Pay at 7-11',
    cheque: 'Pay by Cheque',
  },
  PaymentLinkCart: {
    title: 'Payment',
    Step1: 'CONFIRM DETAILS',
    Step2: 'PAYMENT',
    Step3: 'COMPLETION',
    VisaText: 'This payment method will be saved securely and used for next transaction',
    error: 'Invalid Renew Date',
    hrefError: 'Invalid Payment Link',
    WILMemberReminder:
      'Become a WIL member with 1 step to earn points from monthly rental, an extra 2 hours of free parking, and a $100 Caltex Instant Fuel reward!',
    regNow: 'Join Now',
    skip: 'Skip',
    showAgain: 'Don`t show again',
  },
  sevenPayment: {
    alertText1:
      '1. This QR code is valid for 24 hours only. If you are not able to make payment within 24 hours, please open the link in SMS again in order to obtain a new QR code. \n\n2. Upload all receipts, then tap ‘Confirm Payment’. ',
    alertText2: '',
    alertText3: '',
    text1: 'Pay at 7-Eleven',
    text2: 'Please show the QR Code to Cashier for payment',
    text3: '(Please refresh when you return to this page)',
    text4: 'Booking Type :',
    text5: 'Service period :',
    text6: 'Assigned Car : ',
    text7: 'Please upload the receipt after payment',
    text8: 'Limit: HKD$5000',
    text9: 'Upload Receipt',
    text10: 'Back to home page',
    text11: 'Car Park: ',
    errorMsg:
      'Sorry! The system can’t read your receipt and process OCR verification, please upload the receipt again.\n\n1. Payment amount, account number and payment date must be clearly shown in the uploaded image.\n2. Please capture the receipt on a flat surface.\n3. Turn off the flash when capturing the receipt and make sure there is sufficient light.',
    threeTimeError:
      'You have failed to upload and verify the receipt for 3 times. Please contact our customer service team for further assistance',
    failMsg:
      'The system cannot identify your receipt. Please contact car park staff for assistance.',
    valid: 'This QR code is valid for 24 hours only',
    applicable: 'Applicable to monthly parking payment for ',
    Renew: 'Renew',
    complete: 'Complete Payment',
    close: 'Close',
    remove: 'Remove',
    back: 'Back to home page',
    progress: 'Payment in progress',
    no: 'Your reference number is :',
    confirm:
      'A SMS/email confirmation will be sent to you within 2 working days after the payment is accepted.',
    success: 'Successful payment',
    service: 'Service: ',
    receipt: {
      title: 'Receipt content',
      billnumber: 'Bill number:',
      amount: 'Receipt amount: ',
      date: 'Receipt payment date: ',
      time: 'Receipt time:',
      makesure: 'Make sure the receipt information is correct and match with the payment page.',
      reupload: 'Re-upload',
      complete: 'Confirm',
      passed: 'OCR passed',
    },
  },
  chequePayment: {
    alertText1:
      '1.  A 18-digit bill account number will be generated after tapping Close.\n\n2.   Prepare a crossed cheque payable to ‘Wilson Parking(Holdings) Limited’ and approach a Cheque Deposit Machine at HSBC.\n\n3.   On CQM: Select [Bill Payment] > Merchant [Wilson Parking (Holdings) Limited] > [01 Monthly Parking Fee]. Then, key in cheque amount and the 18-digit bill account number.\n\n4.   Insert cheque and keep the advice after payment.\n\n5. Upload receipt, then tap ‘Complete payment’.',
    payBy: 'Pay by cheque at HSBC(CQM)',
    payable: 'Cheque should be made payable to',
    name: '“Wilson Parking (Holdings) Limited”',
    billAc: 'Enter Bill Account Number: ',
    New: '',
    billType: 'Bill Type: ',
    billType1: '01 Monthly Parking Fee',
    bookingType: 'Booking Type',
  },
  fpsPayment: {
    alertText1:
      '1. Please make a screenshot of the QR code.\n\n2. Select `Pay with FPS` and login to your bank account.\n\n3. Upload the saved QR code in the bank’s app, and proceed with the payment.',
    payBy: 'Pay by FPS',
    useCap: 'Please make a screenshot of the QR code',
  },
  Search: {
    search: 'Search Keyword...',
    yourResult: 'SEARCH RESULT FOR:',
    total: 'Total Number of Records: ',
    result: '',
    carPark: 'Car-Park',
    award: 'Award',
  },
  OTP: {
    validate: 'Verify your mobile phone number',
    phone: 'Mobile Phone Number',
    code: 'Verification Code',
    press: 'Send Verification Code ({{seconds}})',
    send: 'SEND SMS',
    resend: 'RESEND',
    confirm: 'Confirm',
    codeError: 'Please enter the verification code ',
    codeAlertError: 'Invalid verification code',
    unkonwError: 'An error has occurred,please try again later.',
  },
  SkiDataMonthlyParkerRecord: {
    import: 'CONFIRM MONTHLY PARKING SERVICE RECORD',
    found:
      'Is the following record(s) correct? Please contact our customer service at 28303845 if necessary.',
    confirm: 'Confirm',
    wp: 'Wilson Parking',
    remind:
      'If you do not want to import the records to your new account,please change to another phone number and try again.',
    ppcard: 'Park泊Card:  ',
    registrationMark: 'Vehicle Registration Mark:  ',
    carPark: 'Car Park:  ',
    back: 'BACK',
  },
  AccountDeletion: {
    surveyTitle: 'Please tell us why you want to delete your account.',
    DUPLICATED_ACCOUNT: 'I have duplicate accounts.',
    ANOTHER_ACCOUNT: 'I want to create another account.',
    NO_CONTACTLESS: 'I no longer use contactless parking or other online services.',
    SELDOM_USE: 'I seldom use Wilson Parking.',
    PRIVACY_CONCERNS: 'I have privacy concerns.',
    MANY_NOTIFICATIONS: 'I get too many emails/ SMS/ push notifications from Wilson Parking.',
    OTHER: 'Other',
    remark: 'Please specify',
    otherError: 'Please specify other reason',
  },
  ErrorCode: {
    CART_005:
      'The registration mark selected is a registered monthly parking vehicle in this car park. Please select again.',
    CART_009: 'Service unavailable\nThe selected monthly service is full.',
    CAR_PLATE_CHANGE_001:
      'Unable to change the vehicle registration mark\n\n<span style="font-size:20px;font-weight:normal">Contact us now\n2830-3845\n\n(Code: {{code}})</span>',
    CAR_PLATE_CHANGE_009: 'You can only change the vehicle registration mark once a month.',
    CAR_PLATE_CHANGE_010:
      'The registration mark selected is an hourly parking vehicle in this car park, you cannot change its status to monthly. Please try again after the vehicle has left this car park.',
    CAR_PLATE_CHANGE_017:
      'The registration mark selected is a registered monthly parking vehicle in this car park.',
  },
};
